import * as React from "react";

const ESFlag = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		height={16}
		width={25}
		viewBox="0 0 25 16"
		{...props}
	>
		<path width={750} height={500} fill="#c60b1e" d="M0 0H25V16.667H0V0z" />
		<path
			width={750}
			height={250}
			y={125}
			fill="#ffc400"
			d="M0 4.167H25V12.5H0V4.167z"
		/>
		<g id="coa" stroke="#000" strokeWidth={0.39}>
			<g id="supporters">
				<g id="crown_left" strokeWidth={0.26}>
					<path
						fill="#ad1519"
						strokeLinejoin="round"
						d="m5.6 7.408s-0.017 0 -0.026 -0.005 -0.038 -0.032 -0.038 -0.032l-0.023 -0.016 -0.021 -0.028s-0.024 -0.039 -0.013 -0.07c0.011 -0.03 0.03 -0.041 0.047 -0.05 0.017 -0.009 0.053 -0.02 0.053 -0.02s0.028 -0.012 0.038 -0.014c0.009 -0.002 0.043 -0.011 0.043 -0.011s0.009 -0.005 0.019 -0.009c0.01 -0.004 0.023 -0.004 0.03 -0.005 0.007 -0.002 0.026 -0.008 0.038 -0.009 0.017 -0.001 0.045 0.003 0.055 0.003s0.041 0.002 0.055 0.002c0.013 0 0.06 -0.004 0.073 -0.004 0.013 0 0.023 -0.002 0.038 0 0.015 0.002 0.041 0.011 0.049 0.014s0.053 0.02 0.07 0.025 0.058 0.012 0.077 0.021c0.019 0.009 0.03 0.024 0.04 0.037 0.009 0.012 0.011 0.026 0.015 0.035 0.004 0.009 0.004 0.028 0 0.037 -0.004 0.009 -0.017 0.027 -0.017 0.027l-0.021 0.034 -0.026 0.021s-0.019 0.018 -0.034 0.016c-0.015 -0.001 -0.168 -0.029 -0.266 -0.029s-0.255 0.029 -0.255 0.029h0z"
					/>
					<g fill="#c8b100">
						<path
							cx={175.66}
							cy={215.68}
							rx={1.38}
							ry={2.5}
							d="M5.901 7.189A0.046 0.083 0 0 1 5.855 7.273A0.046 0.083 0 0 1 5.809 7.189A0.046 0.083 0 0 1 5.901 7.189z"
						/>
						<path
							cx={175.68}
							cy={215.68}
							rx={0.64}
							ry={2.3}
							d="M5.877 7.189A0.021 0.077 0 0 1 5.856 7.266A0.021 0.077 0 0 1 5.835 7.189A0.021 0.077 0 0 1 5.877 7.189z"
						/>
						<path
							stroke="none"
							cx={175.68}
							cy={213.04}
							rx={0.93}
							ry={0.87}
							d="M5.887 7.101A0.031 0.029 0 0 1 5.856 7.13A0.031 0.029 0 0 1 5.825 7.101A0.031 0.029 0 0 1 5.887 7.101z"
							strokeWidth={0.03333333333333333}
						/>
						<path
							strokeWidth={0.01}
							d="m5.899 7.091v0.019h-0.084v-0.019h0.031v-0.044h-0.021v-0.019h0.021v-0.019h0.02v0.019h0.021v0.019h-0.021v0.044h0.033"
						/>
						<path fill="none" d="m5.865 7.073a0.031 0.029 0 1 1 -0.017 0" />
						<path d="m5.856 7.403h-0.16l-0.004 -0.039 -0.008 -0.041 -0.008 -0.051c-0.044 -0.058 -0.085 -0.097 -0.099 -0.088 0.003 -0.011 0.007 -0.019 0.016 -0.024 0.039 -0.023 0.12 0.033 0.181 0.125 0.005 0.008 0.011 0.017 0.015 0.025h0.132c0.005 -0.008 0.01 -0.017 0.015 -0.025 0.061 -0.092 0.142 -0.148 0.181 -0.125 0.009 0.005 0.012 0.013 0.016 0.024 -0.014 -0.008 -0.054 0.03 -0.099 0.088l-0.008 0.051 -0.008 0.041 -0.003 0.039h-0.161z" />
						<path
							fill="none"
							d="m5.585 7.181c0.03 -0.018 0.101 0.038 0.158 0.125m0.385 -0.125c-0.03 -0.018 -0.1 0.038 -0.158 0.125"
						/>
					</g>
					<g id="crown_pt1" fill="#c8b100">
						<path d="m5.619 7.475c-0.007 -0.019 -0.019 -0.036 -0.019 -0.036 0.065 -0.019 0.155 -0.031 0.256 -0.031 0.1 0 0.192 0.012 0.256 0.031 0 0 -0.007 0.013 -0.017 0.03 -0.006 0.01 -0.013 0.027 -0.013 0.027 -0.058 -0.018 -0.134 -0.027 -0.227 -0.027 -0.093 0 -0.182 0.012 -0.229 0.029 0.001 0 -0.003 -0.011 -0.008 -0.023h0" />
						<path d="m5.856 7.558c0.081 0 0.17 -0.013 0.203 -0.021 0.022 -0.007 0.035 -0.016 0.033 -0.028 -0.001 -0.005 -0.006 -0.01 -0.012 -0.013 -0.049 -0.016 -0.136 -0.027 -0.224 -0.027 -0.088 0 -0.176 0.011 -0.224 0.027 -0.006 0.003 -0.011 0.007 -0.012 0.013 -0.002 0.012 0.011 0.021 0.033 0.028 0.033 0.008 0.123 0.021 0.204 0.021z" />
						<path d="m6.116 7.403l-0.02 -0.018s-0.019 0.011 -0.043 0.008c-0.023 -0.004 -0.031 -0.032 -0.031 -0.032s-0.026 0.022 -0.048 0.021c-0.022 -0.002 -0.036 -0.021 -0.036 -0.021s-0.024 0.017 -0.044 0.015c-0.021 -0.002 -0.04 -0.028 -0.04 -0.028s-0.021 0.027 -0.042 0.029c-0.021 0.002 -0.038 -0.018 -0.038 -0.018s-0.009 0.02 -0.036 0.024 -0.049 -0.021 -0.049 -0.021 -0.015 0.024 -0.033 0.031c-0.018 0.006 -0.041 -0.009 -0.041 -0.009s-0.004 0.009 -0.007 0.014 -0.01 0.006 -0.01 0.006l0.006 0.016c0.064 -0.019 0.152 -0.03 0.251 -0.03s0.189 0.012 0.254 0.031l0.007 -0.018h0z" />
						<path d="m5.856 7.316l0.009 0.002c-0.002 0.004 -0.002 0.008 -0.002 0.013 0 0.019 0.017 0.035 0.037 0.035 0.016 0 0.03 -0.01 0.035 -0.024 0 0 0.004 -0.013 0.005 -0.013 0.001 0 0.001 0.014 0.002 0.014 0.002 0.018 0.018 0.03 0.037 0.03 0.021 0 0.037 -0.016 0.037 -0.035 0 -0.001 0 -0.003 0 -0.004l0.012 -0.012 0.006 0.015c-0.002 0.005 -0.003 0.01 -0.003 0.015 0 0.019 0.016 0.034 0.035 0.034 0.012 0 0.023 -0.006 0.029 -0.015l0.008 -0.01v0.012c0 0.011 0.005 0.022 0.016 0.024 0 0 0.013 0.001 0.03 -0.013 0.017 -0.014 0.027 -0.025 0.027 -0.025l0.001 0.014s-0.017 0.028 -0.032 0.037c-0.008 0.005 -0.021 0.01 -0.032 0.008 -0.011 -0.002 -0.018 -0.01 -0.022 -0.02 -0.008 0.005 -0.017 0.007 -0.027 0.007 -0.021 0 -0.04 -0.012 -0.047 -0.029 -0.01 0.01 -0.023 0.017 -0.039 0.017 -0.017 0 -0.032 -0.008 -0.042 -0.019 -0.009 0.009 -0.022 0.014 -0.036 0.014 -0.018 0 -0.035 -0.009 -0.044 -0.023 -0.01 0.014 -0.026 0.023 -0.045 0.023 -0.014 0 -0.027 -0.005 -0.036 -0.014 -0.01 0.012 -0.025 0.019 -0.042 0.019 -0.016 0 -0.029 -0.006 -0.039 -0.017 -0.007 0.017 -0.026 0.029 -0.047 0.029 -0.01 0 -0.019 -0.003 -0.026 -0.007 -0.004 0.01 -0.012 0.019 -0.023 0.02 -0.01 0.002 -0.023 -0.003 -0.031 -0.008 -0.016 -0.009 -0.034 -0.037 -0.034 -0.037l0.002 -0.014s0.01 0.011 0.027 0.025 0.03 0.013 0.03 0.013c0.011 -0.002 0.016 -0.012 0.016 -0.024v-0.012l0.007 0.01c0.006 0.009 0.017 0.015 0.029 0.015 0.02 0 0.035 -0.015 0.035 -0.034 0 -0.006 -0.001 -0.011 -0.003 -0.015l0.006 -0.015 0.012 0.012c0 0.001 0 0.003 0 0.004 0 0.02 0.016 0.035 0.037 0.035 0.018 0 0.034 -0.012 0.037 -0.03 0 0 0 -0.014 0.001 -0.014 0.002 0 0.005 0.013 0.005 0.013 0.005 0.014 0.019 0.024 0.035 0.024 0.02 0 0.037 -0.016 0.037 -0.035 0 -0.005 0 -0.009 -0.002 -0.013l0.01 -0.002h0z" />
						<path
							strokeLinejoin="round"
							d="m5.856 7.408c-0.1 0 -0.191 0.012 -0.256 0.031 -0.004 0.001 -0.01 -0.002 -0.011 -0.006 -0.001 -0.004 0.002 -0.009 0.006 -0.011 0.065 -0.02 0.158 -0.033 0.261 -0.033s0.196 0.013 0.261 0.033c0.004 0.001 0.007 0.006 0.006 0.011 -0.001 0.004 -0.007 0.007 -0.011 0.006 -0.065 -0.019 -0.156 -0.031 -0.256 -0.031z"
						/>
						<path d="m5.514 7.367c0 0 -0.013 -0.016 -0.022 -0.024 -0.007 -0.006 -0.023 -0.011 -0.023 -0.011 0 -0.003 0.009 -0.009 0.019 -0.009 0.006 0 0.012 0.002 0.015 0.007l0.001 -0.007s0.008 0.002 0.012 0.011c0.004 0.01 0.002 0.024 0.002 0.024s-0.002 0.007 -0.005 0.01z" />
						<path d="m5.577 7.341l-0.004 0.022 -0.047 0.005 -0.007 -0.004 0.001 -0.008 0.035 -0.029 0.021 0.014" />
						<path d="m5.515 7.358c0.004 -0.004 0.012 -0.003 0.018 0.002 0.006 0.005 0.008 0.013 0.004 0.017 -0.004 0.004 -0.012 0.003 -0.018 -0.002 -0.006 -0.005 -0.008 -0.013 -0.004 -0.017z" />
						<path d="m5.601 7.363c-0.002 -0.006 0 -0.012 0.004 -0.014 0.005 -0.001 0.01 0.003 0.012 0.009 0.002 0.006 0 0.013 -0.005 0.014 -0.004 0.001 -0.01 -0.003 -0.012 -0.009z" />
						<path d="m5.622 7.335l0.017 0.016 0.041 -0.022 0.003 -0.007 -0.006 -0.006 -0.047 -0.004 -0.008 0.023" />
						<path d="m5.669 7.259l-0.022 0.021 0.029 0.038 0.008 0.003 0.006 -0.006 0.01 -0.046 -0.03 -0.011" />
						<path d="m5.745 7.31l-0.009 0.021 -0.047 -0.004 -0.006 -0.005 0.003 -0.007 0.041 -0.021 0.017 0.017" />
						<path
							cx={170.51}
							cy={219.65}
							rx={0.49}
							ry={0.47}
							d="M5.7 7.322A0.016 0.016 0 0 1 5.684 7.337A0.016 0.016 0 0 1 5.667 7.322A0.016 0.016 0 0 1 5.7 7.322z"
						/>
						<path d="m5.762 7.332c-0.001 -0.007 0.002 -0.012 0.007 -0.013s0.009 0.004 0.01 0.011c0.001 0.006 -0.002 0.012 -0.007 0.013 -0.005 0.001 -0.009 -0.004 -0.01 -0.011z" />
						<path d="m5.793 7.308l0.013 0.019 0.045 -0.014 0.005 -0.006 -0.005 -0.007 -0.044 -0.013 -0.013 0.021" />
						<path d="m5.855 7.238l-0.029 0.017 0.021 0.046 0.007 0.005 0.007 -0.005 0.021 -0.046 -0.029 -0.017" />
						<path d="m5.918 7.308l-0.013 0.019 -0.045 -0.014 -0.005 -0.006 0.005 -0.007 0.045 -0.013 0.013 0.021" />
						<path
							cx={175.67}
							cy={219.21}
							rx={0.49}
							ry={0.47}
							d="M5.872 7.307A0.016 0.016 0 0 1 5.856 7.323A0.016 0.016 0 0 1 5.839 7.307A0.016 0.016 0 0 1 5.872 7.307z"
						/>
						<path d="m5.95 7.332c0.001 -0.007 -0.003 -0.012 -0.007 -0.013s-0.009 0.004 -0.01 0.011c-0.001 0.006 0.002 0.012 0.007 0.013 0.005 0.001 0.009 -0.004 0.01 -0.011z" />
						<path d="m5.966 7.31l0.009 0.021 0.047 -0.004 0.006 -0.005 -0.003 -0.007 -0.041 -0.021 -0.017 0.017" />
						<path d="m6.042 7.259l0.022 0.021 -0.029 0.038 -0.008 0.003 -0.006 -0.006 -0.01 -0.046 0.03 -0.011" />
						<path d="m6.089 7.335l-0.017 0.016 -0.041 -0.022 -0.003 -0.007 0.006 -0.006 0.047 -0.004 0.008 0.023" />
						<path
							cx={180.85}
							cy={219.65}
							rx={0.49}
							ry={0.47}
							d="M6.045 7.322A0.016 0.016 0 0 1 6.028 7.337A0.016 0.016 0 0 1 6.012 7.322A0.016 0.016 0 0 1 6.045 7.322z"
						/>
						<path d="m6.111 7.363c0.002 -0.006 0 -0.012 -0.004 -0.014 -0.005 -0.001 -0.01 0.003 -0.012 0.009 -0.002 0.006 0 0.013 0.005 0.014 0.004 0.001 0.01 -0.003 0.012 -0.009z" />
						<path d="m6.191 7.367c0 0 0.013 -0.016 0.022 -0.024 0.006 -0.006 0.022 -0.011 0.022 -0.011 0 -0.003 -0.009 -0.009 -0.019 -0.009 -0.006 0 -0.012 0.002 -0.015 0.007l-0.001 -0.007s-0.008 0.002 -0.012 0.011c-0.004 0.01 -0.001 0.024 -0.001 0.024s0.001 0.007 0.004 0.01z" />
						<path d="m6.128 7.341l0.004 0.022 0.047 0.005 0.007 -0.004 -0.002 -0.008 -0.035 -0.029 -0.021 0.014" />
						<path d="m6.191 7.358c-0.004 -0.004 -0.012 -0.003 -0.018 0.002s-0.008 0.013 -0.004 0.017c0.004 0.004 0.012 0.003 0.018 -0.002 0.006 -0.005 0.008 -0.013 0.004 -0.017z" />
					</g>
					<g id="crown_pt2" fill="none">
						<path
							fill="#ad1519"
							d="m5.602 7.477l0.01 -0.017 0.022 0.004 -0.013 0.019 -0.019 -0.006"
						/>
						<path
							fill="#058e6e"
							d="m5.695 7.46l-0.023 0.004c-0.006 0.001 -0.012 -0.003 -0.013 -0.009 -0.001 -0.006 0.003 -0.011 0.009 -0.012l0.023 -0.003 0.024 -0.004c0.006 -0.001 0.011 0.003 0.012 0.008 0.001 0.006 -0.003 0.011 -0.009 0.012l-0.024 0.004"
						/>
						<path
							fill="#fff"
							cx={173.19}
							cy={223.3}
							rx={0.44}
							ry={0.41}
							d="M5.788 7.443A0.015 0.014 0 0 1 5.773 7.457A0.015 0.014 0 0 1 5.758 7.443A0.015 0.014 0 0 1 5.788 7.443z"
						/>
						<path
							fill="#ad1519"
							d="m5.857 7.449h-0.032c-0.006 0 -0.011 -0.005 -0.011 -0.01s0.005 -0.01 0.011 -0.01h0.065c0.006 0 0.011 0.005 0.011 0.01s-0.005 0.01 -0.011 0.01h-0.033"
						/>
						<path
							fill="#fff"
							cx={178.16}
							cy={223.3}
							rx={0.44}
							ry={0.41}
							d="M5.953 7.443A0.015 0.014 0 0 1 5.939 7.457A0.015 0.014 0 0 1 5.924 7.443A0.015 0.014 0 0 1 5.953 7.443z"
						/>
						<path
							fill="#058e6e"
							d="m6.017 7.46l0.023 0.004c0.006 0.001 0.012 -0.003 0.013 -0.009 0.001 -0.006 -0.003 -0.011 -0.009 -0.012l-0.023 -0.003 -0.024 -0.004c-0.006 -0.001 -0.012 0.003 -0.012 0.008 -0.001 0.006 0.003 0.011 0.009 0.012l0.024 0.004"
						/>
						<path
							fill="#ad1519"
							d="m6.108 7.478l-0.008 -0.018 -0.022 0.002 0.011 0.02 0.02 -0.004"
						/>
						<path
							fill="#ad1519"
							strokeLinejoin="round"
							d="m5.855 7.539c-0.081 0 -0.154 -0.007 -0.21 -0.022 0.056 -0.014 0.129 -0.023 0.21 -0.023 0.081 0 0.155 0.009 0.211 0.023 -0.056 0.014 -0.13 0.022 -0.211 0.022z"
						/>
						<path
							strokeWidth={0.0003333333333333333}
							d="m5.893 7.536v-0.039m-0.019 0.04l0 -0.041m-0.014 0.042v-0.042"
						/>
						<path strokeWidth={0.0006666666666666666} d="m5.848 7.538v-0.042" />
						<path strokeWidth={0.001} d="m5.836 7.538v-0.042" />
						<path strokeWidth={0.0013333333333333333} d="m5.826 7.538v-0.042" />
						<path strokeWidth={0.0013333333333333333} d="m5.815 7.538v-0.042" />
						<path strokeWidth={0.0016666666666666668} d="m5.805 7.538v-0.042" />
						<path
							strokeWidth={0.002}
							d="m5.787 7.536l0 -0.038m0.009 0.039v-0.04"
						/>
						<path
							strokeWidth={0.0023333333333333335}
							d="m5.77 7.534v-0.035m0.009 0.036l0 -0.038"
						/>
						<path
							strokeWidth={0.0026666666666666666}
							d="m5.747 7.532v-0.031m0.008 0.031v-0.033m0.008 0.034v-0.034"
						/>
						<path strokeWidth={0.003} d="m5.74 7.532v-0.03" />
						<path strokeWidth={0.0033333333333333335} d="m5.732 7.531v-0.028" />
						<path strokeWidth={0.0036666666666666666} d="m5.724 7.53v-0.026" />
						<path
							strokeWidth={0.004}
							d="m5.708 7.527l0 -0.021m0.009 0.022v-0.023"
						/>
						<path strokeWidth={0.004} d="m5.7 7.526v-0.018" />
						<path strokeWidth={0.004333333333333333} d="m5.692 7.524v-0.015" />
						<path strokeWidth={0.004666666666666667} d="m5.684 7.522v-0.012" />
						<path strokeWidth={0.005} d="m5.675 7.521v-0.009" />
						<path strokeWidth={0.006} d="m5.666 7.519v-0.004" />
					</g>
				</g>
				<g id="pillar_left">
					<g fill="#005bbf">
						<path d="m6.376 11.023c-0.051 0 -0.097 -0.011 -0.131 -0.029 -0.033 -0.017 -0.079 -0.027 -0.129 -0.027 -0.05 0 -0.097 0.011 -0.13 0.028 -0.034 0.018 -0.08 0.029 -0.131 0.029 -0.051 0 -0.097 -0.012 -0.131 -0.03 -0.033 -0.016 -0.078 -0.026 -0.126 -0.026 -0.051 0 -0.095 0.01 -0.129 0.027 -0.034 0.018 -0.081 0.029 -0.132 0.029v0.08c0.051 0 0.098 -0.012 0.132 -0.029 0.033 -0.017 0.078 -0.027 0.129 -0.027 0.048 0 0.093 0.01 0.126 0.027 0.034 0.018 0.08 0.03 0.131 0.03 0.051 0 0.097 -0.011 0.131 -0.029 0.034 -0.017 0.08 -0.028 0.13 -0.028 0.05 0 0.095 0.011 0.129 0.028 0.034 0.018 0.079 0.029 0.13 0.029l0.001 -0.08z" />
						<path
							fill="#ccc"
							d="m6.376 11.103c-0.051 0 -0.097 -0.011 -0.131 -0.029 -0.033 -0.017 -0.079 -0.028 -0.129 -0.028 -0.05 0 -0.097 0.011 -0.13 0.028 -0.034 0.018 -0.08 0.029 -0.131 0.029 -0.051 0 -0.097 -0.012 -0.131 -0.03 -0.033 -0.016 -0.078 -0.027 -0.126 -0.027 -0.051 0 -0.095 0.01 -0.129 0.027 -0.034 0.018 -0.081 0.029 -0.132 0.029v0.08c0.051 0 0.098 -0.012 0.132 -0.029 0.033 -0.017 0.078 -0.027 0.129 -0.027 0.048 0 0.093 0.01 0.126 0.027 0.034 0.018 0.08 0.03 0.131 0.03 0.051 0 0.097 -0.011 0.131 -0.029s0.08 -0.028 0.13 -0.028c0.05 0 0.095 0.011 0.129 0.028 0.034 0.018 0.079 0.029 0.13 0.029l0.001 -0.08"
						/>
						<path d="m6.376 11.183c-0.051 0 -0.097 -0.011 -0.131 -0.029 -0.033 -0.017 -0.079 -0.028 -0.129 -0.028 -0.05 0 -0.097 0.011 -0.13 0.028s-0.08 0.029 -0.131 0.029c-0.051 0 -0.097 -0.012 -0.131 -0.03 -0.033 -0.016 -0.078 -0.027 -0.126 -0.027 -0.051 0 -0.095 0.01 -0.129 0.027 -0.034 0.018 -0.081 0.029 -0.132 0.029v0.08c0.051 0 0.098 -0.011 0.132 -0.029 0.033 -0.017 0.078 -0.027 0.129 -0.027 0.048 0 0.093 0.01 0.126 0.026 0.034 0.018 0.08 0.03 0.131 0.03 0.051 0 0.097 -0.011 0.131 -0.028 0.034 -0.017 0.08 -0.028 0.13 -0.028 0.05 0 0.095 0.01 0.129 0.027 0.034 0.018 0.079 0.029 0.13 0.029l0.001 -0.08" />
						<path
							fill="#ccc"
							d="m6.375 11.344c-0.051 0 -0.096 -0.011 -0.13 -0.029 -0.033 -0.017 -0.079 -0.027 -0.129 -0.027 -0.05 0 -0.097 0.01 -0.13 0.028s-0.08 0.029 -0.131 0.029c-0.051 0 -0.097 -0.012 -0.131 -0.03 -0.033 -0.017 -0.078 -0.026 -0.126 -0.026 -0.051 0 -0.095 0.01 -0.129 0.027 -0.034 0.018 -0.081 0.029 -0.132 0.029v-0.08c0.051 0 0.098 -0.012 0.132 -0.03 0.033 -0.017 0.078 -0.027 0.129 -0.027 0.048 0 0.093 0.01 0.126 0.026 0.034 0.018 0.08 0.03 0.131 0.03 0.051 0 0.097 -0.011 0.131 -0.028 0.034 -0.017 0.08 -0.028 0.13 -0.028 0.05 0 0.095 0.01 0.129 0.027 0.034 0.018 0.08 0.029 0.131 0.029l-0.001 0.081"
						/>
						<path d="m6.375 11.424c-0.051 0 -0.096 -0.011 -0.13 -0.029 -0.033 -0.017 -0.079 -0.028 -0.129 -0.028 -0.05 0 -0.097 0.011 -0.13 0.028s-0.08 0.029 -0.131 0.029c-0.051 0 -0.097 -0.012 -0.131 -0.03 -0.033 -0.017 -0.078 -0.027 -0.126 -0.027 -0.051 0 -0.095 0.01 -0.129 0.027 -0.034 0.018 -0.081 0.029 -0.132 0.029v-0.08c0.051 0 0.098 -0.012 0.132 -0.03 0.033 -0.017 0.078 -0.027 0.129 -0.027 0.048 0 0.093 0.01 0.126 0.026 0.034 0.018 0.08 0.03 0.131 0.03 0.051 0 0.097 -0.011 0.131 -0.029s0.08 -0.028 0.13 -0.028c0.05 0 0.095 0.01 0.129 0.027 0.034 0.018 0.079 0.029 0.131 0.029l-0.001 0.08z" />
					</g>
					<g fill="#c8b100">
						<path
							strokeLinejoin="round"
							d="m5.564 10.693c0.002 0.007 0.004 0.013 0.004 0.021 0 0.049 -0.042 0.088 -0.094 0.088h0.765c-0.052 0 -0.094 -0.039 -0.094 -0.088 0 -0.007 0.001 -0.014 0.003 -0.021 -0.004 0.002 -0.01 0.002 -0.015 0.002h-0.556c-0.004 0 -0.01 -0.001 -0.014 -0.002z"
						/>
						<path d="m5.578 10.642h0.556c0.019 0 0.034 0.012 0.034 0.026s-0.015 0.026 -0.034 0.026h-0.556c-0.019 0 -0.034 -0.012 -0.034 -0.026s0.015 -0.026 0.034 -0.026z" />
						<path d="m5.476 10.995h0.762v-0.194h-0.762v0.194z" />
					</g>
					<path fill="#ccc" d="m5.585 10.611h0.542v-2.654h-0.542v2.654z" />
					<path fill="none" d="m5.971 7.96v2.649m0.061 -2.649v2.649" />
					<g fill="#c8b100">
						<path d="m5.486 7.746h0.743v-0.195h-0.743v0.195z" />
						<path
							strokeLinejoin="round"
							d="m5.564 7.875c0.005 -0.002 0.008 -0.002 0.014 -0.002h0.556c0.006 0 0.011 0.001 0.015 0.003 -0.019 -0.006 -0.033 -0.024 -0.033 -0.044s0.015 -0.038 0.034 -0.044c-0.005 0.001 -0.011 0.003 -0.016 0.003h-0.557c-0.006 0 -0.011 0 -0.016 -0.002l0.003 0.001c0.02 0.006 0.031 0.024 0.031 0.043 0 0.019 -0.013 0.038 -0.032 0.044z"
						/>
						<path d="m5.578 7.873h0.556c0.019 0 0.034 0.012 0.034 0.026 0 0.015 -0.015 0.026 -0.034 0.026h-0.556c-0.019 0 -0.034 -0.012 -0.034 -0.026 0 -0.014 0.015 -0.026 0.034 -0.026z" />
						<path d="m5.578 7.746h0.557c0.019 0 0.034 0.01 0.034 0.022 0 0.012 -0.015 0.022 -0.034 0.022h-0.557c-0.019 0 -0.034 -0.01 -0.034 -0.022 0 -0.012 0.015 -0.022 0.034 -0.022z" />
					</g>
				</g>
				<g id="ribbon_left" fill="#ad1519">
					<path d="m5.416 9.954c-0.075 0.043 -0.127 0.088 -0.118 0.11 0.004 0.02 0.028 0.036 0.062 0.058 0.054 0.038 0.087 0.105 0.061 0.136 0.045 -0.036 0.073 -0.09 0.073 -0.15 0 -0.062 -0.03 -0.119 -0.078 -0.155z" />
					<path
						strokeLinejoin="round"
						d="m6.68 8.949c-0.118 -0.049 -0.319 -0.085 -0.55 -0.093 -0.08 0.001 -0.168 0.008 -0.26 0.023 -0.324 0.054 -0.571 0.184 -0.551 0.289 0 0.002 0.001 0.007 0.002 0.009 0 0 -0.121 -0.274 -0.123 -0.284 -0.022 -0.117 0.252 -0.261 0.612 -0.321 0.113 -0.019 0.223 -0.026 0.319 -0.025 0.23 0 0.43 0.03 0.551 0.074l0.001 0.327"
					/>
					<path d="m5.584 9.282c-0.15 -0.011 -0.253 -0.051 -0.265 -0.114 -0.009 -0.05 0.042 -0.106 0.132 -0.156 0.04 0.005 0.086 0.01 0.133 0.01l-0.001 0.26" />
					<path d="m6.128 9.079c0.094 0.014 0.164 0.038 0.199 0.066l0.003 0.006c0.017 0.034 -0.066 0.107 -0.204 0.189l0.001 -0.261" />
					<path
						strokeLinejoin="round"
						d="m5.247 9.794c-0.014 -0.043 0.132 -0.129 0.339 -0.205 0.095 -0.034 0.173 -0.069 0.27 -0.112 0.288 -0.127 0.5 -0.273 0.474 -0.326l-0.003 -0.006c0.015 0.013 0.039 0.275 0.039 0.275 0.026 0.049 -0.168 0.193 -0.433 0.319 -0.085 0.041 -0.264 0.107 -0.348 0.136 -0.151 0.052 -0.301 0.151 -0.288 0.188l-0.05 -0.27v0z"
					/>
				</g>
				<g id="crown_right" strokeWidth={0.26}>
					<path
						fill="#ad1519"
						strokeWidth={0.009000000000000001}
						d="m10.828 7.347s-0.025 0.026 -0.043 0.03c-0.018 0.003 -0.04 -0.016 -0.04 -0.016s-0.016 0.017 -0.036 0.021c-0.02 0.005 -0.047 -0.022 -0.047 -0.022s-0.019 0.027 -0.036 0.033c-0.017 0.006 -0.038 -0.008 -0.038 -0.008s-0.008 0.013 -0.022 0.02c-0.006 0.003 -0.016 -0.002 -0.016 -0.002l-0.02 -0.013 -0.023 -0.024 -0.021 -0.008s-0.009 -0.03 -0.01 -0.036c-0.001 -0.005 -0.003 -0.019 -0.003 -0.019 -0.004 -0.022 0.029 -0.047 0.077 -0.057 0.027 -0.006 0.051 -0.006 0.069 -0.001 0.019 -0.016 0.059 -0.027 0.107 -0.027 0.043 0 0.081 0.009 0.101 0.023 0.02 -0.014 0.058 -0.023 0.101 -0.023 0.047 0 0.087 0.011 0.106 0.027 0.018 -0.005 0.041 -0.006 0.069 0.001 0.047 0.011 0.081 0.036 0.077 0.057 0 0 -0.002 0.014 -0.003 0.019 -0.001 0.005 -0.011 0.036 -0.011 0.036l-0.021 0.008 -0.023 0.024 -0.019 0.013s-0.01 0.005 -0.016 0.002c-0.014 -0.007 -0.022 -0.02 -0.022 -0.02s-0.021 0.014 -0.038 0.008c-0.017 -0.006 -0.036 -0.033 -0.036 -0.033s-0.027 0.027 -0.047 0.022c-0.02 -0.004 -0.036 -0.021 -0.036 -0.021s-0.023 0.02 -0.04 0.016c-0.018 -0.004 -0.042 -0.03 -0.042 -0.03z"
					/>
					<g fill="#c8b100">
						<path
							cx={324.82}
							cy={216.2}
							rx={1.38}
							ry={1.96}
							d="M10.873 7.207A0.046 0.065 0 0 1 10.827 7.272A0.046 0.065 0 0 1 10.781 7.207A0.046 0.065 0 0 1 10.873 7.207z"
						/>
						<path
							cx={324.85}
							cy={216.2}
							rx={0.63}
							ry={1.81}
							d="M10.849 7.207A0.021 0.06 0 0 1 10.828 7.267A0.021 0.06 0 0 1 10.807 7.207A0.021 0.06 0 0 1 10.849 7.207z"
						/>
						<path
							stroke="none"
							cx={324.84}
							cy={213.95}
							rx={0.93}
							ry={0.88}
							d="M10.859 7.132A0.031 0.029 0 0 1 10.828 7.161A0.031 0.029 0 0 1 10.797 7.132A0.031 0.029 0 0 1 10.859 7.132z"
							strokeWidth={0.03333333333333333}
						/>
						<path
							strokeWidth={0.01}
							d="m10.871 7.121v0.019h-0.084v-0.019h0.031v-0.043h-0.021v-0.019h0.021v-0.019h0.02v0.019h0.02v0.019h-0.02v0.043h0.033"
						/>
						<path fill="none" d="m10.837 7.104a0.031 0.029 0 1 1 -0.017 0" />
					</g>
					<g fill="none" strokeWidth={0.21}>
						<path
							strokeWidth={0.008666666666666666}
							strokeLinecap="round"
							d="m10.48 7.333c-0.004 -0.011 -0.007 -0.023 -0.007 -0.036 0 -0.053 0.042 -0.096 0.094 -0.096 0.017 0 0.032 0.004 0.046 0.012"
						/>
						<path
							strokeWidth={0.008666666666666666}
							d="m10.649 7.264c-0.005 -0.009 -0.01 -0.018 -0.01 -0.028 0 -0.038 0.04 -0.069 0.088 -0.069 0.021 0 0.04 0.006 0.055 0.015"
						/>
						<path
							strokeWidth={0.008666666666666666}
							d="m11.006 7.265c0.005 -0.009 0.008 -0.019 0.008 -0.029 0 -0.038 -0.039 -0.069 -0.088 -0.069 -0.021 0 -0.04 0.006 -0.055 0.015"
						/>
						<path
							strokeWidth={0.008666666666666666}
							strokeLinecap="round"
							d="m11.174 7.333c0.004 -0.011 0.007 -0.023 0.007 -0.036 0 -0.053 -0.042 -0.096 -0.094 -0.096 -0.017 0 -0.032 0.004 -0.046 0.012"
						/>
						<path
							cx={313.57}
							cy={218.68}
							rx={0.45}
							ry={0.43}
							d="M10.467 7.289A0.015 0.014 0 0 1 10.452 7.304A0.015 0.014 0 0 1 10.437 7.289A0.015 0.014 0 0 1 10.467 7.289z"
						/>
						<path
							cx={313.74}
							cy={217.1}
							rx={0.45}
							ry={0.43}
							d="M10.473 7.237A0.015 0.014 0 0 1 10.458 7.251A0.015 0.014 0 0 1 10.443 7.237A0.015 0.014 0 0 1 10.473 7.237z"
						/>
						<path
							cx={314.76}
							cy={215.9}
							rx={0.45}
							ry={0.43}
							d="M10.507 7.197A0.015 0.014 0 0 1 10.492 7.211A0.015 0.014 0 0 1 10.477 7.197A0.015 0.014 0 0 1 10.507 7.197z"
						/>
						<path
							cx={316.11}
							cy={215.25}
							rx={0.45}
							ry={0.43}
							d="M10.552 7.175A0.015 0.014 0 0 1 10.537 7.189A0.015 0.014 0 0 1 10.522 7.175A0.015 0.014 0 0 1 10.552 7.175z"
						/>
						<path
							cx={317.55}
							cy={215.31}
							rx={0.45}
							ry={0.43}
							d="M10.6 7.177A0.015 0.014 0 0 1 10.585 7.191A0.015 0.014 0 0 1 10.57 7.177A0.015 0.014 0 0 1 10.6 7.177z"
						/>
						<path
							fill="#fff"
							cx={318.43}
							cy={217.08}
							rx={0.45}
							ry={0.43}
							d="M10.629 7.236A0.015 0.014 0 0 1 10.614 7.25A0.015 0.014 0 0 1 10.599 7.236A0.015 0.014 0 0 1 10.629 7.236z"
						/>
						<path
							cx={318.68}
							cy={215.58}
							rx={0.45}
							ry={0.43}
							d="M10.638 7.186A0.015 0.014 0 0 1 10.623 7.2A0.015 0.014 0 0 1 10.608 7.186A0.015 0.014 0 0 1 10.638 7.186z"
						/>
						<path
							cx={319.81}
							cy={214.64}
							rx={0.45}
							ry={0.43}
							d="M10.675 7.155A0.015 0.014 0 0 1 10.66 7.169A0.015 0.014 0 0 1 10.645 7.155A0.015 0.014 0 0 1 10.675 7.155z"
						/>
						<path
							cx={321.23}
							cy={214.19}
							rx={0.45}
							ry={0.43}
							d="M10.723 7.14A0.015 0.014 0 0 1 10.708 7.154A0.015 0.014 0 0 1 10.693 7.14A0.015 0.014 0 0 1 10.723 7.14z"
						/>
						<path
							cx={322.67}
							cy={214.24}
							rx={0.45}
							ry={0.43}
							d="M10.771 7.141A0.015 0.014 0 0 1 10.756 7.156A0.015 0.014 0 0 1 10.741 7.141A0.015 0.014 0 0 1 10.771 7.141z"
						/>
						<path
							cx={326.94}
							cy={214.24}
							rx={0.45}
							ry={0.43}
							d="M10.913 7.141A0.015 0.014 0 0 1 10.898 7.156A0.015 0.014 0 0 1 10.883 7.141A0.015 0.014 0 0 1 10.913 7.141z"
						/>
						<path
							cx={328.39}
							cy={214.19}
							rx={0.45}
							ry={0.43}
							d="M10.961 7.14A0.015 0.014 0 0 1 10.946 7.154A0.015 0.014 0 0 1 10.931 7.14A0.015 0.014 0 0 1 10.961 7.14z"
						/>
						<path
							cx={329.8}
							cy={214.64}
							rx={0.45}
							ry={0.43}
							d="M11.008 7.155A0.015 0.014 0 0 1 10.993 7.169A0.015 0.014 0 0 1 10.978 7.155A0.015 0.014 0 0 1 11.008 7.155z"
						/>
						<path
							cx={330.93}
							cy={215.58}
							rx={0.45}
							ry={0.43}
							d="M11.046 7.186A0.015 0.014 0 0 1 11.031 7.2A0.015 0.014 0 0 1 11.016 7.186A0.015 0.014 0 0 1 11.046 7.186z"
						/>
						<path
							fill="#fff"
							cx={331.18}
							cy={217.08}
							rx={0.45}
							ry={0.43}
							d="M11.054 7.236A0.015 0.014 0 0 1 11.039 7.25A0.015 0.014 0 0 1 11.024 7.236A0.015 0.014 0 0 1 11.054 7.236z"
						/>
						<path
							cx={332.06}
							cy={215.31}
							rx={0.45}
							ry={0.43}
							d="M11.084 7.177A0.015 0.014 0 0 1 11.069 7.191A0.015 0.014 0 0 1 11.054 7.177A0.015 0.014 0 0 1 11.084 7.177z"
						/>
						<path
							cx={333.51}
							cy={215.25}
							rx={0.45}
							ry={0.43}
							d="M11.132 7.175A0.015 0.014 0 0 1 11.117 7.189A0.015 0.014 0 0 1 11.102 7.175A0.015 0.014 0 0 1 11.132 7.175z"
						/>
						<path
							cx={334.86}
							cy={215.9}
							rx={0.45}
							ry={0.43}
							d="M11.177 7.197A0.015 0.014 0 0 1 11.162 7.211A0.015 0.014 0 0 1 11.147 7.197A0.015 0.014 0 0 1 11.177 7.197z"
						/>
						<path
							cx={335.88}
							cy={217.1}
							rx={0.45}
							ry={0.43}
							d="M11.211 7.237A0.015 0.014 0 0 1 11.196 7.251A0.015 0.014 0 0 1 11.181 7.237A0.015 0.014 0 0 1 11.211 7.237z"
						/>
						<path
							cx={336.05}
							cy={218.68}
							rx={0.45}
							ry={0.43}
							d="M11.217 7.289A0.015 0.014 0 0 1 11.202 7.304A0.015 0.014 0 0 1 11.187 7.289A0.015 0.014 0 0 1 11.217 7.289z"
						/>
					</g>
					<use xlinkHref="#crown_pt1" x={149.17} />
					<use xlinkHref="#crown_pt2" x={149.17} />
				</g>
				<use id="pillar_right" xlinkHref="#pillar_left" x={149.17} />
				<use
					id="ribbon_right"
					xlinkHref="#ribbon_left"
					transform="matrix(-1,0,0,1,500.57,0)"
				/>
				<g id="plus_ultra" fill="#c8b100" stroke="none">
					<path d="m5.547 8.822c0.066 -0.024 0.11 -0.053 0.089 -0.105 -0.014 -0.033 -0.048 -0.04 -0.099 -0.021l-0.09 0.033 0.081 0.201c0.009 -0.004 0.018 -0.008 0.027 -0.011 0.009 -0.003 0.019 -0.006 0.028 -0.009l-0.036 -0.088v0zm-0.039 -0.097l0.023 -0.008c0.019 -0.007 0.04 0.003 0.05 0.027 0.007 0.018 0.005 0.038 -0.017 0.052 -0.007 0.004 -0.015 0.008 -0.023 0.011l-0.033 -0.081" />
					<path d="m5.759 8.641c-0.01 0.003 -0.019 0.005 -0.029 0.007 -0.01 0.002 -0.02 0.003 -0.029 0.004l0.047 0.209 0.146 -0.029c-0.002 -0.004 -0.004 -0.009 -0.005 -0.013 -0.001 -0.005 -0.001 -0.009 -0.001 -0.014 -0.026 0.007 -0.054 0.015 -0.087 0.022l-0.042 -0.187" />
					<path d="m6.052 8.821c0.027 -0.076 0.061 -0.149 0.094 -0.222 -0.006 0.001 -0.012 0.002 -0.018 0.002s-0.012 0 -0.018 0c-0.018 0.054 -0.039 0.107 -0.062 0.16 -0.027 -0.05 -0.058 -0.1 -0.081 -0.15 -0.011 0.001 -0.023 0.003 -0.034 0.004 -0.011 0.001 -0.023 0 -0.035 0.001 0.042 0.069 0.083 0.137 0.121 0.208 0.005 -0.001 0.011 -0.002 0.017 -0.003 0.005 0 0.011 0 0.017 0.001" />
					<path d="m6.357 8.66c0.005 -0.01 0.01 -0.02 0.016 -0.03 -0.008 -0.007 -0.032 -0.018 -0.06 -0.021 -0.06 -0.006 -0.094 0.02 -0.098 0.056 -0.009 0.075 0.11 0.069 0.105 0.119 -0.002 0.021 -0.025 0.03 -0.049 0.028 -0.027 -0.003 -0.047 -0.018 -0.05 -0.04l-0.007 -0.001c-0.004 0.013 -0.01 0.026 -0.016 0.038 0.018 0.011 0.04 0.018 0.062 0.02 0.061 0.006 0.107 -0.018 0.112 -0.058 0.008 -0.072 -0.112 -0.076 -0.108 -0.118 0.002 -0.018 0.016 -0.029 0.047 -0.026 0.022 0.002 0.036 0.014 0.042 0.032l0.006 0.001" />
					<path d="m10.343 8.833c0.021 -0.078 0.047 -0.153 0.073 -0.229 -0.006 0.002 -0.012 0.003 -0.018 0.004 -0.006 0.001 -0.012 0.001 -0.018 0.002 -0.012 0.055 -0.029 0.11 -0.047 0.165 -0.032 -0.048 -0.067 -0.095 -0.094 -0.143 -0.011 0.002 -0.023 0.005 -0.034 0.007s-0.023 0.002 -0.035 0.004c0.048 0.065 0.095 0.13 0.14 0.197 0.005 -0.001 0.011 -0.003 0.017 -0.004 0.005 -0.001 0.011 -0.001 0.016 -0.001" />
					<path d="m10.549 8.605c-0.01 0 -0.02 0.001 -0.029 0.001 -0.01 0 -0.02 -0.001 -0.03 -0.002l-0.004 0.214 0.15 0.003c-0.001 -0.004 -0.002 -0.009 -0.002 -0.014s0.001 -0.009 0.002 -0.013c-0.027 0.002 -0.056 0.003 -0.09 0.003l0.003 -0.191" />
					<path d="m10.784 8.64c0.024 0.002 0.047 0.006 0.07 0.01 0 -0.004 -0.001 -0.009 -0.001 -0.014 0 -0.004 0.002 -0.009 0.003 -0.013l-0.202 -0.017c0 0.005 0.001 0.009 0.001 0.013 0 0.005 -0.002 0.009 -0.003 0.013 0.021 -0.001 0.046 -0.001 0.074 0.002l-0.018 0.192c0.01 0 0.02 0 0.029 0.001 0.01 0.001 0.02 0.002 0.029 0.004l0.018 -0.192" />
					<path d="m10.867 8.851c0.01 0.002 0.02 0.003 0.029 0.005 0.009 0.002 0.019 0.005 0.028 0.008l0.024 -0.098 0.003 0c0.005 0.014 0.013 0.03 0.016 0.04l0.03 0.074c0.012 0.002 0.024 0.004 0.035 0.006 0.012 0.003 0.023 0.006 0.035 0.009l-0.01 -0.022c-0.016 -0.033 -0.033 -0.067 -0.047 -0.101 0.037 0.001 0.066 -0.012 0.073 -0.042 0.005 -0.021 -0.003 -0.037 -0.023 -0.051 -0.015 -0.01 -0.043 -0.016 -0.061 -0.02l-0.081 -0.018 -0.051 0.21m0.105 -0.181c0.024 0.005 0.053 0.009 0.053 0.036 0 0.007 -0.001 0.012 -0.002 0.016 -0.008 0.031 -0.031 0.042 -0.071 0.03l0.02 -0.082" />
					<path d="m11.252 8.915c-0.002 0.023 -0.006 0.046 -0.01 0.07 0.01 0.005 0.02 0.009 0.03 0.015 0.01 0.005 0.019 0.011 0.029 0.017l0.02 -0.241c-0.005 -0.002 -0.009 -0.004 -0.014 -0.006 -0.004 -0.002 -0.008 -0.005 -0.012 -0.008l-0.213 0.135c0.006 0.003 0.012 0.005 0.017 0.008 0.006 0.003 0.01 0.006 0.016 0.009 0.018 -0.015 0.037 -0.027 0.058 -0.043l0.08 0.044v0zm-0.06 -0.055l0.071 -0.046 -0.008 0.08 -0.063 -0.034" />
				</g>
			</g>
			<g id="crown_crest">
				<path
					fill="#ad1519"
					strokeWidth={0.008666666666666666}
					d="m8.322 6.091c0.221 0 0.419 0.033 0.547 0.084 0.073 0.033 0.172 0.058 0.28 0.072 0.082 0.011 0.16 0.013 0.228 0.008 0.091 -0.002 0.222 0.025 0.354 0.083 0.109 0.048 0.2 0.107 0.26 0.164l-0.052 0.047 -0.015 0.132 -0.143 0.164 -0.072 0.061 -0.17 0.136 -0.087 0.007 -0.026 0.075 -1.097 -0.129 -1.101 0.129 -0.026 -0.075 -0.087 -0.007 -0.169 -0.136 -0.072 -0.061 -0.143 -0.164 -0.015 -0.132 -0.053 -0.047c0.061 -0.057 0.151 -0.115 0.26 -0.164 0.132 -0.058 0.263 -0.085 0.354 -0.083 0.068 0.005 0.146 0.003 0.228 -0.008 0.108 -0.015 0.207 -0.039 0.28 -0.072 0.129 -0.051 0.315 -0.084 0.536 -0.084z"
				/>
				<g fill="#c8b100">
					<path d="m7.511 6.381l0.046 0.037 0.069 -0.113c-0.075 -0.046 -0.127 -0.126 -0.127 -0.217 0 -0.01 0.001 -0.02 0.002 -0.03 0.007 -0.145 0.183 -0.264 0.407 -0.264 0.116 0 0.221 0.032 0.295 0.083 0.002 -0.022 0.004 -0.042 0.007 -0.062 -0.081 -0.047 -0.187 -0.076 -0.302 -0.076 -0.257 0 -0.458 0.146 -0.468 0.319 -0.001 0.01 -0.002 0.02 -0.002 0.031 0 0.092 0.042 0.175 0.109 0.233l-0.037 0.06" />
					<path d="m7.514 6.382c-0.088 -0.066 -0.142 -0.155 -0.142 -0.253 0 -0.113 0.074 -0.213 0.186 -0.28 -0.069 0.056 -0.111 0.128 -0.117 0.208 -0.001 0.01 -0.002 0.02 -0.002 0.031 0 0.092 0.042 0.175 0.109 0.233l-0.034 0.062" />
					<path d="m6.74 6.496c-0.049 -0.055 -0.079 -0.126 -0.079 -0.204 0 -0.047 0.011 -0.092 0.03 -0.132 0.071 -0.146 0.294 -0.252 0.559 -0.252 0.072 0 0.141 0.008 0.205 0.022 -0.014 0.015 -0.025 0.032 -0.036 0.049 -0.053 -0.01 -0.11 -0.016 -0.169 -0.016 -0.242 0 -0.445 0.094 -0.504 0.222 -0.016 0.032 -0.024 0.069 -0.024 0.107 0 0.077 0.036 0.147 0.093 0.194l-0.088 0.143 -0.047 -0.037 0.06 -0.096z" />
					<path d="m6.83 6.016c-0.064 0.04 -0.112 0.09 -0.139 0.145 -0.019 0.04 -0.03 0.085 -0.03 0.132 0 0.078 0.03 0.149 0.079 0.204l-0.053 0.086c-0.051 -0.065 -0.081 -0.142 -0.081 -0.223 0 -0.14 0.089 -0.262 0.224 -0.343z" />
					<path d="m8.335 5.709c0.059 0 0.109 0.039 0.121 0.091 0.008 0.046 0.013 0.098 0.014 0.154 0 0.006 0 0.012 0 0.017 0 0.007 0.001 0.014 0.002 0.02 0.002 0.117 0.019 0.221 0.042 0.284l-0.179 0.171 -0.181 -0.171c0.024 -0.063 0.041 -0.167 0.043 -0.284 0 -0.007 0.001 -0.014 0.001 -0.02 0 -0.006 0 -0.011 0 -0.017 0.001 -0.056 0.006 -0.108 0.014 -0.154 0.012 -0.052 0.065 -0.091 0.123 -0.091z" />
					<path d="m8.335 5.765c0.03 0 0.056 0.019 0.062 0.046 0.008 0.044 0.012 0.093 0.013 0.146 0 0.005 0 0.011 0 0.016 0 0.007 0.001 0.013 0.001 0.02 0.002 0.111 0.018 0.208 0.04 0.268l-0.118 0.112 -0.118 -0.112c0.022 -0.06 0.038 -0.158 0.04 -0.268 0 -0.007 0.001 -0.013 0.001 -0.02 0 -0.005 0 -0.011 0 -0.016 0.001 -0.053 0.006 -0.102 0.013 -0.146 0.006 -0.027 0.034 -0.046 0.064 -0.046z" />
					<path d="m9.157 6.381l-0.046 0.037 -0.069 -0.113c0.075 -0.046 0.127 -0.126 0.127 -0.217 0 -0.01 -0.001 -0.02 -0.002 -0.03 -0.007 -0.145 -0.183 -0.264 -0.407 -0.264 -0.116 0 -0.221 0.032 -0.295 0.083 -0.002 -0.022 -0.004 -0.042 -0.007 -0.062 0.081 -0.047 0.187 -0.076 0.302 -0.076 0.257 0 0.458 0.146 0.468 0.319 0.001 0.01 0.002 0.02 0.002 0.031 0 0.092 -0.042 0.175 -0.109 0.233l0.037 0.06" />
					<path d="m9.154 6.382c0.088 -0.066 0.142 -0.155 0.142 -0.253 0 -0.113 -0.074 -0.213 -0.186 -0.28 0.069 0.056 0.111 0.128 0.117 0.208 0.001 0.01 0.002 0.02 0.002 0.031 0 0.092 -0.042 0.175 -0.109 0.233l0.034 0.062" />
					<path d="m9.928 6.496c0.049 -0.055 0.079 -0.126 0.079 -0.204 0 -0.047 -0.011 -0.092 -0.03 -0.132 -0.071 -0.146 -0.294 -0.252 -0.559 -0.252 -0.072 0 -0.141 0.008 -0.205 0.022 0.014 0.015 0.025 0.032 0.036 0.049 0.053 -0.01 0.11 -0.016 0.169 -0.016 0.242 0 0.445 0.094 0.504 0.222 0.016 0.032 0.024 0.069 0.024 0.107 0 0.077 -0.036 0.147 -0.093 0.194l0.088 0.143 0.047 -0.037 -0.06 -0.096z" />
					<path d="m9.838 6.016c0.064 0.04 0.112 0.09 0.139 0.145 0.019 0.04 0.03 0.085 0.03 0.132 0 0.078 -0.03 0.149 -0.079 0.204l0.053 0.086c0.051 -0.065 0.08 -0.142 0.08 -0.223 0 -0.14 -0.089 -0.262 -0.223 -0.343z" />
					<path
						fill="#005bbf"
						strokeWidth={0.008666666666666666}
						cx={250.05}
						cy={167.3}
						rx={4.43}
						ry={4.2}
						d="M8.483 5.577A0.148 0.14 0 0 1 8.335 5.717A0.148 0.14 0 0 1 8.187 5.577A0.148 0.14 0 0 1 8.483 5.577z"
					/>
					<path
						strokeWidth={0.008666666666666666}
						d="m8.296 5.185v0.075h-0.081v0.077h0.081v0.105h-0.102c-0.001 0.007 -0.007 0.012 -0.007 0.02 0 0.019 0.004 0.038 0.012 0.055 0 0.001 0.001 0.001 0.001 0.001h0.271c0 0 0.001 0 0.001 -0.001 0.007 -0.017 0.012 -0.035 0.012 -0.055 0 -0.007 -0.006 -0.013 -0.007 -0.02h-0.099v-0.114h0.081v-0.077h-0.081v-0.075h-0.081z"
					/>
				</g>
				<g fill="#fff">
					<path
						cx={250.04}
						cy={188.94}
						rx={1.91}
						ry={1.8}
						d="M8.398 6.298A0.064 0.06 0 0 1 8.335 6.358A0.064 0.06 0 0 1 8.271 6.298A0.064 0.06 0 0 1 8.398 6.298z"
					/>
					<path
						cx={250.04}
						cy={185.4}
						rx={1.91}
						ry={1.8}
						d="M8.398 6.18A0.064 0.06 0 0 1 8.335 6.24A0.064 0.06 0 0 1 8.271 6.18A0.064 0.06 0 0 1 8.398 6.18z"
					/>
					<path
						cx={250.04}
						cy={181.6}
						rx={1.52}
						ry={1.44}
						d="M8.385 6.053A0.051 0.048 0 0 1 8.335 6.101A0.051 0.048 0 0 1 8.284 6.053A0.051 0.048 0 0 1 8.385 6.053z"
					/>
					<path
						cx={250.04}
						cy={178.18}
						rx={1.1}
						ry={1.04}
						d="M8.371 5.939A0.037 0.035 0 0 1 8.335 5.974A0.037 0.035 0 0 1 8.298 5.939A0.037 0.035 0 0 1 8.371 5.939z"
					/>
					<path
						cx={250.04}
						cy={175.18}
						rx={0.88}
						ry={0.83}
						d="M8.364 5.839A0.029 0.028 0 0 1 8.335 5.867A0.029 0.028 0 0 1 8.305 5.839A0.029 0.028 0 0 1 8.364 5.839z"
					/>
					<path
						cx={198.94}
						cy={198.67}
						rx={1.1}
						ry={1.04}
						d="M6.668 6.622A0.037 0.035 0 0 1 6.631 6.657A0.037 0.035 0 0 1 6.595 6.622A0.037 0.035 0 0 1 6.668 6.622z"
					/>
					<path
						cx={197.44}
						cy={196.02}
						rx={1.1}
						ry={1.04}
						d="M6.618 6.534A0.037 0.035 0 0 1 6.581 6.569A0.037 0.035 0 0 1 6.545 6.534A0.037 0.035 0 0 1 6.618 6.534z"
					/>
					<path
						cx={196.44}
						cy={192.94}
						rx={1.1}
						ry={1.04}
						d="M6.585 6.431A0.037 0.035 0 0 1 6.548 6.466A0.037 0.035 0 0 1 6.511 6.431A0.037 0.035 0 0 1 6.585 6.431z"
					/>
					<path
						cx={196.31}
						cy={189.64}
						rx={1.1}
						ry={1.04}
						d="M6.58 6.321A0.037 0.035 0 0 1 6.544 6.356A0.037 0.035 0 0 1 6.507 6.321A0.037 0.035 0 0 1 6.58 6.321z"
					/>
					<path
						cx={197.12}
						cy={186.4}
						rx={1.1}
						ry={1.04}
						d="M6.607 6.213A0.037 0.035 0 0 1 6.571 6.248A0.037 0.035 0 0 1 6.534 6.213A0.037 0.035 0 0 1 6.607 6.213z"
					/>
					<path
						cx={198.81}
						cy={183.45}
						rx={1.1}
						ry={1.04}
						d="M6.664 6.115A0.037 0.035 0 0 1 6.627 6.15A0.037 0.035 0 0 1 6.59 6.115A0.037 0.035 0 0 1 6.664 6.115z"
					/>
					<path
						cx={201.06}
						cy={181.02}
						rx={1.1}
						ry={1.04}
						d="M6.739 6.034A0.037 0.035 0 0 1 6.702 6.069A0.037 0.035 0 0 1 6.665 6.034A0.037 0.035 0 0 1 6.739 6.034z"
					/>
					<path
						cx={203.68}
						cy={179.01}
						rx={1.1}
						ry={1.04}
						d="M6.826 5.967A0.037 0.035 0 0 1 6.789 6.002A0.037 0.035 0 0 1 6.753 5.967A0.037 0.035 0 0 1 6.826 5.967z"
					/>
					<path
						cx={206.8}
						cy={177.36}
						rx={1.1}
						ry={1.04}
						d="M6.93 5.912A0.037 0.035 0 0 1 6.893 5.947A0.037 0.035 0 0 1 6.857 5.912A0.037 0.035 0 0 1 6.93 5.912z"
					/>
					<path
						cx={210.04}
						cy={176.19}
						rx={1.1}
						ry={1.04}
						d="M7.038 5.873A0.037 0.035 0 0 1 7.001 5.908A0.037 0.035 0 0 1 6.965 5.873A0.037 0.035 0 0 1 7.038 5.873z"
					/>
					<path
						cx={213.66}
						cy={175.54}
						rx={1.1}
						ry={1.04}
						d="M7.159 5.851A0.037 0.035 0 0 1 7.122 5.886A0.037 0.035 0 0 1 7.085 5.851A0.037 0.035 0 0 1 7.159 5.851z"
					/>
					<path
						cx={217.1}
						cy={175.36}
						rx={1.1}
						ry={1.04}
						d="M7.273 5.845A0.037 0.035 0 0 1 7.237 5.88A0.037 0.035 0 0 1 7.2 5.845A0.037 0.035 0 0 1 7.273 5.845z"
					/>
					<path
						cx={220.47}
						cy={175.48}
						rx={1.1}
						ry={1.04}
						d="M7.386 5.849A0.037 0.035 0 0 1 7.349 5.884A0.037 0.035 0 0 1 7.312 5.849A0.037 0.035 0 0 1 7.386 5.849z"
					/>
					<path
						cx={224.21}
						cy={190.32}
						rx={1.1}
						ry={1.04}
						d="M7.51 6.344A0.037 0.035 0 0 1 7.474 6.379A0.037 0.035 0 0 1 7.437 6.344A0.037 0.035 0 0 1 7.51 6.344z"
					/>
					<path
						cx={222.34}
						cy={187.65}
						rx={1.1}
						ry={1.04}
						d="M7.448 6.255A0.037 0.035 0 0 1 7.411 6.29A0.037 0.035 0 0 1 7.375 6.255A0.037 0.035 0 0 1 7.448 6.255z"
					/>
					<path
						cx={221.35}
						cy={184.75}
						rx={1.1}
						ry={1.04}
						d="M7.415 6.158A0.037 0.035 0 0 1 7.378 6.193A0.037 0.035 0 0 1 7.342 6.158A0.037 0.035 0 0 1 7.415 6.158z"
					/>
					<path
						cx={221.47}
						cy={181.57}
						rx={1.1}
						ry={1.04}
						d="M7.419 6.052A0.037 0.035 0 0 1 7.382 6.087A0.037 0.035 0 0 1 7.346 6.052A0.037 0.035 0 0 1 7.419 6.052z"
					/>
					<path
						cx={222.16}
						cy={178.37}
						rx={1.1}
						ry={1.04}
						d="M7.442 5.946A0.037 0.035 0 0 1 7.405 5.98A0.037 0.035 0 0 1 7.369 5.946A0.037 0.035 0 0 1 7.442 5.946z"
					/>
					<path
						cx={223.84}
						cy={175.48}
						rx={1.1}
						ry={1.04}
						d="M7.498 5.849A0.037 0.035 0 0 1 7.461 5.884A0.037 0.035 0 0 1 7.425 5.849A0.037 0.035 0 0 1 7.498 5.849z"
					/>
					<path
						cx={226.4}
						cy={173.47}
						rx={1.1}
						ry={1.04}
						d="M7.583 5.782A0.037 0.035 0 0 1 7.547 5.817A0.037 0.035 0 0 1 7.51 5.782A0.037 0.035 0 0 1 7.583 5.782z"
					/>
					<path
						cx={229.39}
						cy={171.81}
						rx={1.1}
						ry={1.04}
						d="M7.683 5.727A0.037 0.035 0 0 1 7.646 5.762A0.037 0.035 0 0 1 7.61 5.727A0.037 0.035 0 0 1 7.683 5.727z"
					/>
					<path
						cx={232.7}
						cy={170.82}
						rx={1.1}
						ry={1.04}
						d="M7.793 5.694A0.037 0.035 0 0 1 7.757 5.729A0.037 0.035 0 0 1 7.72 5.694A0.037 0.035 0 0 1 7.793 5.694z"
					/>
					<path
						cx={236.13}
						cy={170.23}
						rx={1.1}
						ry={1.04}
						d="M7.908 5.674A0.037 0.035 0 0 1 7.871 5.709A0.037 0.035 0 0 1 7.834 5.674A0.037 0.035 0 0 1 7.908 5.674z"
					/>
					<path
						cx={239.5}
						cy={170.28}
						rx={1.1}
						ry={1.04}
						d="M8.02 5.676A0.037 0.035 0 0 1 7.983 5.711A0.037 0.035 0 0 1 7.947 5.676A0.037 0.035 0 0 1 8.02 5.676z"
					/>
					<path
						cx={242.99}
						cy={170.87}
						rx={1.1}
						ry={1.04}
						d="M8.136 5.696A0.037 0.035 0 0 1 8.1 5.73A0.037 0.035 0 0 1 8.063 5.696A0.037 0.035 0 0 1 8.136 5.696z"
					/>
					<path
						cx={246.23}
						cy={171.99}
						rx={1.1}
						ry={1.04}
						d="M8.244 5.733A0.037 0.035 0 0 1 8.208 5.768A0.037 0.035 0 0 1 8.171 5.733A0.037 0.035 0 0 1 8.244 5.733z"
					/>
					<path
						cx={253.8}
						cy={171.99}
						rx={1.1}
						ry={1.04}
						d="M8.497 5.733A0.037 0.035 0 0 1 8.46 5.768A0.037 0.035 0 0 1 8.423 5.733A0.037 0.035 0 0 1 8.497 5.733z"
					/>
					<path
						cx={257.04}
						cy={170.87}
						rx={1.1}
						ry={1.04}
						d="M8.605 5.696A0.037 0.035 0 0 1 8.568 5.73A0.037 0.035 0 0 1 8.531 5.696A0.037 0.035 0 0 1 8.605 5.696z"
					/>
					<path
						cx={260.54}
						cy={170.28}
						rx={1.1}
						ry={1.04}
						d="M8.721 5.676A0.037 0.035 0 0 1 8.685 5.711A0.037 0.035 0 0 1 8.648 5.676A0.037 0.035 0 0 1 8.721 5.676z"
					/>
					<path
						cx={263.9}
						cy={170.23}
						rx={1.1}
						ry={1.04}
						d="M8.833 5.674A0.037 0.035 0 0 1 8.797 5.709A0.037 0.035 0 0 1 8.76 5.674A0.037 0.035 0 0 1 8.833 5.674z"
					/>
					<path
						cx={267.34}
						cy={170.82}
						rx={1.1}
						ry={1.04}
						d="M8.948 5.694A0.037 0.035 0 0 1 8.911 5.729A0.037 0.035 0 0 1 8.875 5.694A0.037 0.035 0 0 1 8.948 5.694z"
					/>
					<path
						cx={270.64}
						cy={171.81}
						rx={1.1}
						ry={1.04}
						d="M9.058 5.727A0.037 0.035 0 0 1 9.021 5.762A0.037 0.035 0 0 1 8.985 5.727A0.037 0.035 0 0 1 9.058 5.727z"
					/>
					<path
						cx={273.64}
						cy={173.47}
						rx={1.1}
						ry={1.04}
						d="M9.158 5.782A0.037 0.035 0 0 1 9.121 5.817A0.037 0.035 0 0 1 9.085 5.782A0.037 0.035 0 0 1 9.158 5.782z"
					/>
					<path
						cx={276.19}
						cy={175.48}
						rx={1.1}
						ry={1.04}
						d="M9.243 5.849A0.037 0.035 0 0 1 9.206 5.884A0.037 0.035 0 0 1 9.17 5.849A0.037 0.035 0 0 1 9.243 5.849z"
					/>
					<path
						cx={277.88}
						cy={178.37}
						rx={1.1}
						ry={1.04}
						d="M9.299 5.946A0.037 0.035 0 0 1 9.263 5.98A0.037 0.035 0 0 1 9.226 5.946A0.037 0.035 0 0 1 9.299 5.946z"
					/>
					<path
						cx={278.57}
						cy={181.57}
						rx={1.1}
						ry={1.04}
						d="M9.322 6.052A0.037 0.035 0 0 1 9.286 6.087A0.037 0.035 0 0 1 9.249 6.052A0.037 0.035 0 0 1 9.322 6.052z"
					/>
					<path
						cx={278.69}
						cy={184.75}
						rx={1.1}
						ry={1.04}
						d="M9.326 6.158A0.037 0.035 0 0 1 9.29 6.193A0.037 0.035 0 0 1 9.253 6.158A0.037 0.035 0 0 1 9.326 6.158z"
					/>
					<path
						cx={277.69}
						cy={187.65}
						rx={1.1}
						ry={1.04}
						d="M9.293 6.255A0.037 0.035 0 0 1 9.256 6.29A0.037 0.035 0 0 1 9.22 6.255A0.037 0.035 0 0 1 9.293 6.255z"
					/>
					<path
						cx={275.83}
						cy={190.32}
						rx={1.1}
						ry={1.04}
						d="M9.231 6.344A0.037 0.035 0 0 1 9.194 6.379A0.037 0.035 0 0 1 9.158 6.344A0.037 0.035 0 0 1 9.231 6.344z"
					/>
					<path
						cx={279.57}
						cy={175.48}
						rx={1.1}
						ry={1.04}
						d="M9.356 5.849A0.037 0.035 0 0 1 9.319 5.884A0.037 0.035 0 0 1 9.282 5.849A0.037 0.035 0 0 1 9.356 5.849z"
					/>
					<path
						cx={282.94}
						cy={175.36}
						rx={1.1}
						ry={1.04}
						d="M9.468 5.845A0.037 0.035 0 0 1 9.431 5.88A0.037 0.035 0 0 1 9.395 5.845A0.037 0.035 0 0 1 9.468 5.845z"
					/>
					<path
						cx={286.38}
						cy={175.54}
						rx={1.1}
						ry={1.04}
						d="M9.583 5.851A0.037 0.035 0 0 1 9.546 5.886A0.037 0.035 0 0 1 9.509 5.851A0.037 0.035 0 0 1 9.583 5.851z"
					/>
					<path
						cx={290}
						cy={176.19}
						rx={1.1}
						ry={1.04}
						d="M9.703 5.873A0.037 0.035 0 0 1 9.667 5.908A0.037 0.035 0 0 1 9.63 5.873A0.037 0.035 0 0 1 9.703 5.873z"
					/>
					<path
						cx={293.24}
						cy={177.36}
						rx={1.1}
						ry={1.04}
						d="M9.811 5.912A0.037 0.035 0 0 1 9.775 5.947A0.037 0.035 0 0 1 9.738 5.912A0.037 0.035 0 0 1 9.811 5.912z"
					/>
					<path
						cx={296.36}
						cy={179.01}
						rx={1.1}
						ry={1.04}
						d="M9.915 5.967A0.037 0.035 0 0 1 9.879 6.002A0.037 0.035 0 0 1 9.842 5.967A0.037 0.035 0 0 1 9.915 5.967z"
					/>
					<path
						cx={298.97}
						cy={181.02}
						rx={1.1}
						ry={1.04}
						d="M10.002 6.034A0.037 0.035 0 0 1 9.966 6.069A0.037 0.035 0 0 1 9.929 6.034A0.037 0.035 0 0 1 10.002 6.034z"
					/>
					<path
						cx={301.22}
						cy={183.45}
						rx={1.1}
						ry={1.04}
						d="M10.077 6.115A0.037 0.035 0 0 1 10.041 6.15A0.037 0.035 0 0 1 10.004 6.115A0.037 0.035 0 0 1 10.077 6.115z"
					/>
					<path
						cx={302.91}
						cy={186.4}
						rx={1.1}
						ry={1.04}
						d="M10.134 6.213A0.037 0.035 0 0 1 10.097 6.248A0.037 0.035 0 0 1 10.06 6.213A0.037 0.035 0 0 1 10.134 6.213z"
					/>
					<path
						cx={303.72}
						cy={189.64}
						rx={1.1}
						ry={1.04}
						d="M10.161 6.321A0.037 0.035 0 0 1 10.124 6.356A0.037 0.035 0 0 1 10.087 6.321A0.037 0.035 0 0 1 10.161 6.321z"
					/>
					<path
						cx={303.6}
						cy={192.94}
						rx={1.1}
						ry={1.04}
						d="M10.157 6.431A0.037 0.035 0 0 1 10.12 6.466A0.037 0.035 0 0 1 10.083 6.431A0.037 0.035 0 0 1 10.157 6.431z"
					/>
					<path
						cx={302.6}
						cy={196.02}
						rx={1.1}
						ry={1.04}
						d="M10.123 6.534A0.037 0.035 0 0 1 10.087 6.569A0.037 0.035 0 0 1 10.05 6.534A0.037 0.035 0 0 1 10.123 6.534z"
					/>
					<path
						cx={301.1}
						cy={198.67}
						rx={1.1}
						ry={1.04}
						d="M10.073 6.622A0.037 0.035 0 0 1 10.037 6.657A0.037 0.035 0 0 1 10 6.622A0.037 0.035 0 0 1 10.073 6.622z"
					/>
				</g>
				<g fill="#c8b100">
					<path d="m8.338 7.539c-0.409 -0.001 -0.775 -0.049 -1.036 -0.128 -0.019 -0.006 -0.029 -0.023 -0.028 -0.042 0 -0.017 0.01 -0.033 0.028 -0.039 0.261 -0.079 0.628 -0.127 1.036 -0.128 0.409 0.001 0.775 0.049 1.036 0.128 0.018 0.006 0.028 0.022 0.028 0.039 0.001 0.018 -0.009 0.036 -0.028 0.042 -0.261 0.079 -0.627 0.127 -1.036 0.128" />
					<path d="m8.336 7.203c-0.414 0.001 -0.785 0.053 -1.046 0.133 0.022 -0.01 0.02 -0.037 -0.007 -0.107 -0.033 -0.084 -0.083 -0.081 -0.083 -0.081 0.289 -0.085 0.691 -0.139 1.139 -0.139 0.448 0.001 0.853 0.054 1.142 0.139 0 0 -0.051 -0.004 -0.084 0.081 -0.027 0.069 -0.029 0.096 -0.007 0.107 -0.261 -0.081 -0.64 -0.132 -1.053 -0.133" />
					<path d="m8.337 7.01c-0.448 0.001 -0.85 0.054 -1.139 0.139 -0.019 0.006 -0.04 -0.002 -0.046 -0.02s0.004 -0.039 0.023 -0.045c0.29 -0.089 0.703 -0.145 1.161 -0.146 0.459 0.001 0.873 0.057 1.163 0.146 0.019 0.006 0.03 0.027 0.023 0.045s-0.027 0.026 -0.046 0.02c-0.289 -0.085 -0.693 -0.139 -1.141 -0.139" />
					<path d="m8.34 6.659l0.041 0.007c-0.006 0.017 -0.008 0.035 -0.008 0.054 0 0.086 0.074 0.155 0.164 0.155 0.073 0 0.135 -0.045 0.156 -0.107 0.003 0.002 0.016 -0.056 0.023 -0.055 0.006 0.001 0.005 0.06 0.007 0.059 0.01 0.078 0.082 0.131 0.162 0.131 0.09 0 0.164 -0.069 0.164 -0.155 0 -0.006 0 -0.013 -0.001 -0.019l0.051 -0.051 0.028 0.065c-0.011 0.02 -0.015 0.043 -0.015 0.068 0 0.082 0.07 0.148 0.156 0.148 0.054 0 0.102 -0.026 0.13 -0.066l0.033 -0.042 0 0.051c0 0.052 0.022 0.098 0.072 0.106 0 0 0.058 0.003 0.134 -0.057 0.076 -0.06 0.118 -0.11 0.118 -0.11l0.007 0.06s-0.063 0.098 -0.132 0.138c-0.038 0.022 -0.095 0.045 -0.141 0.038 -0.048 -0.008 -0.083 -0.047 -0.1 -0.091 -0.034 0.02 -0.075 0.032 -0.118 0.032 -0.094 0 -0.178 -0.051 -0.211 -0.129 -0.043 0.047 -0.103 0.075 -0.173 0.075 -0.075 0 -0.143 -0.034 -0.186 -0.085 -0.042 0.039 -0.099 0.062 -0.163 0.062 -0.083 0 -0.156 -0.041 -0.198 -0.102 -0.042 0.061 -0.115 0.102 -0.198 0.102 -0.063 0 -0.12 -0.024 -0.162 -0.062 -0.043 0.052 -0.111 0.085 -0.186 0.085 -0.07 0 -0.13 -0.028 -0.173 -0.075 -0.033 0.077 -0.117 0.129 -0.211 0.129 -0.044 0 -0.084 -0.012 -0.118 -0.032 -0.018 0.045 -0.052 0.083 -0.101 0.091 -0.045 0.007 -0.103 -0.016 -0.141 -0.038 -0.069 -0.04 -0.133 -0.138 -0.133 -0.138l0.007 -0.06s0.042 0.05 0.119 0.11c0.076 0.06 0.134 0.057 0.134 0.057 0.05 -0.008 0.072 -0.054 0.072 -0.106l0 -0.051 0.033 0.042c0.028 0.04 0.076 0.066 0.13 0.066 0.086 0 0.156 -0.066 0.156 -0.148 0 -0.024 -0.004 -0.047 -0.015 -0.068l0.028 -0.065 0.051 0.051c-0.001 0.006 -0.001 0.013 -0.001 0.019 0 0.086 0.073 0.155 0.164 0.155 0.081 0 0.152 -0.053 0.163 -0.131 0.002 0.001 0.002 -0.058 0.007 -0.059 0.007 -0.001 0.02 0.057 0.022 0.055 0.021 0.062 0.083 0.107 0.156 0.107 0.09 0 0.164 -0.069 0.164 -0.155 0 -0.019 -0.001 -0.038 -0.008 -0.054l0.043 -0.007" />
					<path d="m6.946 6.877c-0.004 -0.012 -0.012 -0.025 -0.024 -0.035 -0.026 -0.023 -0.061 -0.026 -0.079 -0.008 -0.002 0.002 -0.004 0.006 -0.006 0.008 0 0 -0.037 -0.069 -0.08 -0.093 -0.043 -0.023 -0.116 -0.017 -0.116 -0.017 0 -0.053 0.043 -0.096 0.1 -0.096 0.033 0 0.064 0.014 0.083 0.037l0.008 -0.036s0.045 0.009 0.066 0.061 -0.002 0.127 -0.002 0.127 0.011 -0.032 0.028 -0.054c0.017 -0.021 0.06 -0.045 0.083 -0.055 0.022 -0.01 0.046 -0.026 0.046 -0.026s0.001 0.006 0.002 0.02c0.001 0.017 0 0.028 0 0.028 0.041 -0.006 0.09 0.001 0.128 0.016 -0.016 0.032 -0.047 0.061 -0.087 0.077 0 0 0.015 0.012 0.028 0.025 0.011 0.011 0.015 0.016 0.015 0.016s-0.028 0.004 -0.042 0.006c-0.014 0.002 -0.061 0.009 -0.09 0.007 -0.021 -0.001 -0.044 -0.005 -0.058 -0.007" />
					<path
						fill="#ad1519"
						d="m6.843 6.834c0.017 -0.018 0.052 -0.014 0.079 0.008 0.027 0.022 0.034 0.055 0.017 0.073 -0.017 0.018 -0.052 0.014 -0.079 -0.008 -0.026 -0.023 -0.034 -0.055 -0.017 -0.073"
					/>
					<path
						fill="#fff"
						d="m7.213 6.864c-0.009 -0.028 -0.001 -0.055 0.019 -0.061 0.02 -0.006 0.044 0.011 0.053 0.039s0.001 0.055 -0.019 0.061c-0.02 0.006 -0.044 -0.011 -0.053 -0.039"
					/>
					<path d="m7.537 6.729c-0.011 -0.009 -0.02 -0.021 -0.022 -0.036s0 -0.029 0.008 -0.041c0 0 -0.029 -0.015 -0.061 -0.023 -0.024 -0.006 -0.066 -0.007 -0.079 -0.007 -0.013 -0.001 -0.038 -0.001 -0.038 -0.001s0.002 0.006 0.009 0.018c0.009 0.015 0.017 0.025 0.017 0.025 -0.042 0.01 -0.078 0.037 -0.101 0.07 0.033 0.023 0.077 0.037 0.12 0.032 0 0 -0.004 0.011 -0.007 0.029 -0.002 0.014 -0.002 0.02 -0.002 0.02s0.024 -0.009 0.036 -0.013c0.012 -0.004 0.051 -0.018 0.072 -0.032 0.027 -0.018 0.049 -0.042 0.049 -0.042" />
					<path d="m7.523 6.388c0.035 0.022 0.066 0.06 0.077 0.101 0 0 0.004 -0.008 0.024 -0.02 0.02 -0.011 0.036 -0.011 0.036 -0.011s-0.006 0.032 -0.008 0.044c-0.003 0.011 -0.003 0.046 -0.011 0.077 -0.008 0.031 -0.021 0.056 -0.021 0.056 -0.014 -0.011 -0.033 -0.017 -0.053 -0.014 -0.019 0.003 -0.035 0.015 -0.044 0.03 0 0 -0.022 -0.019 -0.04 -0.046 -0.018 -0.027 -0.031 -0.059 -0.038 -0.069 -0.007 -0.01 -0.024 -0.038 -0.024 -0.038s0.016 -0.006 0.038 -0.002c0.022 0.004 0.029 0.011 0.029 0.011 -0.005 -0.043 0.009 -0.087 0.035 -0.12" />
					<path d="m7.632 6.713c0.007 -0.012 0.011 -0.026 0.008 -0.041s-0.011 -0.027 -0.022 -0.036c0 0 0.022 -0.024 0.049 -0.042 0.02 -0.014 0.06 -0.027 0.072 -0.032 0.012 -0.004 0.036 -0.013 0.036 -0.013s0 0.006 -0.002 0.02c-0.003 0.017 -0.007 0.029 -0.007 0.029 0.043 -0.005 0.087 0.01 0.12 0.033 -0.023 0.032 -0.059 0.06 -0.101 0.069 0 0 0.008 0.009 0.017 0.025 0.007 0.013 0.009 0.019 0.009 0.019s-0.026 -0.001 -0.038 -0.001c-0.013 0 -0.055 0 -0.079 -0.007 -0.032 -0.008 -0.061 -0.023 -0.061 -0.023" />
					<path
						fill="#ad1519"
						cx={227.37}
						cy={200.45}
						rx={2.17}
						ry={2.06}
						d="M7.651 6.682A0.072 0.069 0 0 1 7.579 6.75A0.072 0.069 0 0 1 7.507 6.682A0.072 0.069 0 0 1 7.651 6.682z"
					/>
					<path
						fill="#fff"
						d="m7.925 6.726c-0.004 -0.029 0.01 -0.054 0.031 -0.057 0.021 -0.002 0.041 0.019 0.045 0.048 0.004 0.029 -0.01 0.054 -0.031 0.057 -0.021 0.002 -0.041 -0.019 -0.045 -0.048"
					/>
					<path d="m8.283 6.661c-0.011 -0.012 -0.018 -0.027 -0.018 -0.044 0 -0.017 0.006 -0.032 0.017 -0.044 0 0 -0.03 -0.022 -0.063 -0.037 -0.026 -0.012 -0.073 -0.02 -0.087 -0.022 -0.014 -0.003 -0.043 -0.008 -0.043 -0.008s0.001 0.007 0.007 0.022c0.007 0.019 0.013 0.031 0.013 0.031 -0.049 0.003 -0.095 0.027 -0.127 0.059 0.032 0.031 0.078 0.055 0.127 0.058 0 0 -0.007 0.012 -0.013 0.031 -0.005 0.015 -0.007 0.022 -0.007 0.022s0.028 -0.005 0.043 -0.008c0.014 -0.003 0.061 -0.011 0.087 -0.022 0.033 -0.015 0.064 -0.037 0.064 -0.037" />
					<path d="m8.337 6.279c0.035 0.032 0.062 0.079 0.065 0.127 0 0 0.006 -0.009 0.03 -0.018 0.024 -0.009 0.043 -0.005 0.043 -0.005s-0.013 0.035 -0.018 0.047c-0.006 0.012 -0.013 0.051 -0.028 0.084 -0.015 0.033 -0.035 0.059 -0.035 0.059 -0.013 -0.015 -0.033 -0.025 -0.056 -0.025 -0.023 0 -0.042 0.01 -0.056 0.025 0 0 -0.02 -0.025 -0.035 -0.059 -0.015 -0.033 -0.022 -0.072 -0.028 -0.084s-0.019 -0.047 -0.019 -0.047 0.019 -0.003 0.043 0.005 0.031 0.018 0.031 0.018c0.003 -0.049 0.029 -0.096 0.063 -0.127" />
					<path d="m8.392 6.661c0.011 -0.012 0.018 -0.027 0.018 -0.044 0 -0.017 -0.006 -0.032 -0.017 -0.044 0 0 0.03 -0.022 0.063 -0.037 0.025 -0.012 0.072 -0.02 0.087 -0.022 0.014 -0.003 0.042 -0.008 0.042 -0.008s-0.001 0.007 -0.006 0.022c-0.007 0.019 -0.013 0.031 -0.013 0.031 0.049 0.003 0.095 0.027 0.127 0.059 -0.032 0.031 -0.078 0.055 -0.127 0.058 0 0 0.007 0.012 0.013 0.031 0.005 0.015 0.006 0.022 0.006 0.022l-0.042 -0.008c-0.014 -0.003 -0.061 -0.011 -0.087 -0.022 -0.034 -0.015 -0.064 -0.037 -0.064 -0.037" />
					<path
						fill="#ad1519"
						cx={250.14}
						cy={198.5}
						rx={2.17}
						ry={2.06}
						d="M8.41 6.617A0.072 0.069 0 0 1 8.338 6.685A0.072 0.069 0 0 1 8.266 6.617A0.072 0.069 0 0 1 8.41 6.617z"
					/>
					<path
						fill="#fff"
						d="m8.753 6.726c0.004 -0.029 -0.01 -0.054 -0.031 -0.057s-0.041 0.019 -0.045 0.048c-0.004 0.029 0.01 0.054 0.031 0.057 0.021 0.002 0.041 -0.019 0.045 -0.048"
					/>
					<path d="m9.046 6.713c-0.007 -0.012 -0.011 -0.026 -0.008 -0.041 0.003 -0.015 0.011 -0.027 0.022 -0.036 0 0 -0.022 -0.024 -0.049 -0.042 -0.02 -0.014 -0.06 -0.027 -0.072 -0.032 -0.012 -0.004 -0.035 -0.013 -0.035 -0.013s0 0.006 0.002 0.02c0.003 0.017 0.006 0.029 0.006 0.029 -0.043 -0.005 -0.087 0.01 -0.12 0.033 0.023 0.032 0.059 0.06 0.101 0.069 0 0 -0.008 0.009 -0.016 0.025 -0.007 0.013 -0.009 0.019 -0.009 0.019l0.038 -0.001c0.013 0 0.055 0 0.079 -0.007 0.032 -0.008 0.061 -0.023 0.061 -0.023" />
					<path d="m9.156 6.388c-0.035 0.022 -0.066 0.06 -0.077 0.101 0 0 -0.004 -0.008 -0.024 -0.02 -0.019 -0.011 -0.036 -0.011 -0.036 -0.011s0.006 0.032 0.009 0.044c0.003 0.011 0.003 0.046 0.01 0.077 0.008 0.031 0.021 0.056 0.021 0.056 0.014 -0.011 0.033 -0.017 0.052 -0.014 0.02 0.003 0.035 0.015 0.044 0.03 0 0 0.022 -0.019 0.04 -0.046 0.018 -0.027 0.031 -0.059 0.037 -0.069 0.007 -0.01 0.024 -0.038 0.024 -0.038s-0.016 -0.006 -0.038 -0.002c-0.022 0.004 -0.029 0.011 -0.029 0.011 0.005 -0.043 -0.009 -0.087 -0.034 -0.12" />
					<path d="m9.141 6.729c0.011 -0.009 0.02 -0.021 0.022 -0.036 0.003 -0.015 0 -0.029 -0.007 -0.041 0 0 0.029 -0.015 0.061 -0.023 0.024 -0.006 0.066 -0.007 0.079 -0.007 0.013 -0.001 0.038 -0.001 0.038 -0.001s-0.002 0.006 -0.009 0.018c-0.009 0.015 -0.016 0.025 -0.016 0.025 0.042 0.01 0.078 0.037 0.101 0.07 -0.033 0.023 -0.077 0.037 -0.12 0.032 0 0 0.004 0.011 0.006 0.029 0.002 0.014 0.002 0.02 0.002 0.02s-0.024 -0.009 -0.035 -0.013c-0.012 -0.004 -0.052 -0.018 -0.072 -0.032 -0.026 -0.018 -0.049 -0.042 -0.049 -0.042" />
					<path
						fill="#ad1519"
						cx={272.98}
						cy={200.45}
						rx={2.17}
						ry={2.06}
						d="M9.172 6.682A0.072 0.069 0 0 1 9.099 6.75A0.072 0.069 0 0 1 9.027 6.682A0.072 0.069 0 0 1 9.172 6.682z"
					/>
					<path
						fill="#fff"
						d="m9.465 6.864c0.009 -0.028 0.001 -0.055 -0.019 -0.061 -0.02 -0.006 -0.044 0.011 -0.054 0.039 -0.009 0.028 -0.001 0.055 0.019 0.061 0.02 0.006 0.044 -0.011 0.054 -0.039"
					/>
					<path d="m9.732 6.877c0.004 -0.012 0.012 -0.025 0.024 -0.035 0.026 -0.023 0.062 -0.026 0.079 -0.008 0.002 0.002 0.005 0.006 0.006 0.008 0 0 0.037 -0.069 0.08 -0.093s0.117 -0.017 0.117 -0.017c0 -0.053 -0.044 -0.096 -0.1 -0.096 -0.033 0 -0.064 0.014 -0.082 0.037l-0.008 -0.036s-0.045 0.009 -0.066 0.061 0.002 0.127 0.002 0.127 -0.011 -0.032 -0.028 -0.054c-0.017 -0.021 -0.06 -0.045 -0.083 -0.055 -0.023 -0.01 -0.046 -0.026 -0.046 -0.026s-0.001 0.006 -0.002 0.02c-0.001 0.017 0.001 0.028 0.001 0.028 -0.042 -0.006 -0.09 0.001 -0.128 0.016 0.016 0.032 0.047 0.061 0.087 0.077 0 0 -0.014 0.012 -0.028 0.025 -0.011 0.011 -0.014 0.016 -0.014 0.016s0.028 0.004 0.042 0.006c0.014 0.002 0.061 0.009 0.089 0.007 0.021 -0.001 0.044 -0.005 0.058 -0.007" />
					<path
						fill="#ad1519"
						d="m9.835 6.834c-0.017 -0.018 -0.052 -0.014 -0.079 0.008 -0.026 0.022 -0.034 0.055 -0.017 0.073 0.017 0.018 0.052 0.014 0.079 -0.008 0.026 -0.023 0.034 -0.055 0.017 -0.073"
					/>
				</g>
				<g fill="none">
					<path
						fill="#ad1519"
						strokeLinejoin="round"
						d="m8.337 7.486c-0.369 0 -0.702 -0.043 -0.956 -0.109 0.254 -0.066 0.587 -0.106 0.956 -0.106 0.369 0.001 0.704 0.041 0.958 0.106 -0.254 0.066 -0.589 0.108 -0.958 0.109z"
					/>
					<path
						strokeWidth={0.0016666666666666668}
						d="m8.601 7.476v-0.2m-0.101 0.207l0.001 -0.212m-0.075 0.215v-0.216"
					/>
					<path strokeWidth={0.003} d="m8.365 7.488v-0.219" />
					<path strokeWidth={0.004666666666666667} d="m8.305 7.488v-0.219" />
					<path strokeWidth={0.006} d="m8.249 7.488v-0.219" />
					<path strokeWidth={0.007666666666666667} d="m8.194 7.488v-0.219" />
					<path strokeWidth={0.009333333333333334} d="m8.144 7.488v-0.219" />
					<path
						strokeWidth={0.011000000000000001}
						d="m8.049 7.476l-0.001 -0.199m0.046 0.202v-0.208"
					/>
					<path
						strokeWidth={0.012333333333333333}
						d="m7.962 7.467v-0.183m0.044 0.189l-0.001 -0.195"
					/>
					<path
						strokeWidth={0.013999999999999999}
						d="m7.845 7.457v-0.161m0.038 0.164v-0.169m0.04 0.175v-0.176"
					/>
					<path strokeWidth={0.015333333333333334} d="m7.804 7.455v-0.156" />
					<path strokeWidth={0.017} d="m7.766 7.447v-0.145" />
					<path strokeWidth={0.018666666666666668} d="m7.725 7.444v-0.135" />
					<path
						strokeWidth={0.02}
						d="m7.641 7.432l-0.001 -0.107m0.044 0.113v-0.121"
					/>
					<path strokeWidth={0.021} d="m7.598 7.423v-0.095" />
					<path strokeWidth={0.02266666666666667} d="m7.558 7.415v-0.079" />
					<path strokeWidth={0.024333333333333332} d="m7.515 7.404v-0.062" />
					<path strokeWidth={0.025666666666666667} d="m7.471 7.399v-0.046" />
					<path strokeWidth={0.030333333333333334} d="m7.424 7.389v-0.022" />
					<path d="m7.337 7.389c0.258 -0.073 0.61 -0.117 1 -0.118 0.391 0.001 0.744 0.045 1.002 0.118" />
					<path
						fill="#ad1519"
						d="m7.224 7.239l0.041 -0.053 0.112 0.014 -0.09 0.065 -0.063 -0.027"
					/>
					<path
						fill="#fff"
						d="m7.468 7.176c0 -0.019 0.016 -0.035 0.037 -0.035s0.037 0.015 0.037 0.035c0 0.019 -0.016 0.035 -0.037 0.035s-0.037 -0.016 -0.037 -0.035"
					/>
					<path
						fill="#058e6e"
						d="m7.788 7.169l-0.079 0.009c-0.02 0.002 -0.039 -0.011 -0.041 -0.03 -0.003 -0.019 0.012 -0.036 0.032 -0.038l0.079 -0.009 0.081 -0.009c0.02 -0.002 0.038 0.011 0.041 0.03s-0.012 0.036 -0.032 0.039l-0.08 0.009"
					/>
					<path
						fill="#fff"
						d="m8.018 7.112c0 -0.019 0.016 -0.035 0.037 -0.035 0.02 0 0.037 0.015 0.037 0.035 0 0.019 -0.017 0.035 -0.037 0.035 -0.02 0 -0.037 -0.016 -0.037 -0.035"
					/>
					<path
						fill="#ad1519"
						d="m8.338 7.139h-0.11c-0.02 0 -0.037 -0.015 -0.037 -0.034 0 -0.019 0.016 -0.035 0.037 -0.035h0.221c0.02 0 0.037 0.015 0.037 0.035 0 0.019 -0.017 0.034 -0.037 0.034h-0.111"
					/>
					<path
						fill="#fff"
						d="m8.585 7.112c0 -0.019 0.017 -0.035 0.037 -0.035 0.02 0 0.037 0.015 0.037 0.035 0 0.019 -0.016 0.035 -0.037 0.035 -0.02 0 -0.037 -0.016 -0.037 -0.035"
					/>
					<path
						fill="#058e6e"
						d="m8.889 7.169l0.079 0.009c0.02 0.002 0.039 -0.011 0.041 -0.03s-0.012 -0.036 -0.032 -0.038l-0.079 -0.009 -0.081 -0.009c-0.02 -0.002 -0.038 0.011 -0.041 0.03 -0.003 0.019 0.012 0.036 0.032 0.039l0.08 0.009"
					/>
					<path
						fill="#fff"
						d="m9.136 7.176c0 -0.019 0.016 -0.035 0.037 -0.035s0.037 0.015 0.037 0.035c0 0.019 -0.016 0.035 -0.037 0.035s-0.037 -0.016 -0.037 -0.035"
					/>
					<path
						fill="#ad1519"
						d="m9.452 7.239l-0.04 -0.053 -0.112 0.014 0.09 0.065 0.063 -0.027"
					/>
				</g>
			</g>
			<g id="shield" strokeWidth={0.52}>
				<g id="Granada">
					<path
						fill="#ccc"
						d="m8.35 11.478c-0.436 0 -0.868 -0.107 -1.232 -0.285 -0.268 -0.133 -0.445 -0.4 -0.445 -0.706v-1.11h3.347v1.11c0 0.306 -0.177 0.574 -0.445 0.706 -0.363 0.178 -0.789 0.285 -1.225 0.285z"
					/>
					<path
						fill="#ffd691"
						d="m8.43 10.985c0.07 0.021 0.105 0.073 0.105 0.134 0 0.079 -0.077 0.139 -0.177 0.139 -0.1 0 -0.181 -0.06 -0.181 -0.139 0 -0.06 0.033 -0.127 0.103 -0.131 0 0 -0.002 -0.006 -0.008 -0.017 -0.007 -0.008 -0.021 -0.022 -0.021 -0.022s0.026 -0.005 0.042 0.001c0.015 0.006 0.026 0.016 0.026 0.016s0.007 -0.014 0.017 -0.025c0.01 -0.011 0.023 -0.018 0.023 -0.018s0.015 0.013 0.02 0.021c0.005 0.009 0.008 0.02 0.008 0.02s0.014 -0.012 0.026 -0.016c0.012 -0.005 0.028 -0.009 0.028 -0.009s-0.004 0.015 -0.007 0.023 -0.005 0.024 -0.005 0.024"
					/>
					<path
						fill="#058e6e"
						d="m8.344 11.344s-0.133 -0.089 -0.19 -0.101c-0.074 -0.016 -0.156 -0.003 -0.192 -0.005 0.001 0.001 0.043 0.031 0.061 0.049s0.08 0.055 0.114 0.064c0.107 0.027 0.206 -0.007 0.206 -0.007"
					/>
					<path
						fill="#058e6e"
						d="m8.382 11.352s0.085 -0.089 0.174 -0.101c0.105 -0.015 0.174 0.009 0.215 0.019 0.001 0 -0.034 0.016 -0.052 0.029 -0.018 0.012 -0.066 0.052 -0.138 0.053 -0.073 0.001 -0.153 -0.008 -0.166 -0.006 -0.013 0.002 -0.033 0.005 -0.033 0.005"
					/>
					<path
						fill="#ad1519"
						d="m8.356 11.243c-0.033 -0.031 -0.054 -0.075 -0.054 -0.124 0 -0.049 0.021 -0.093 0.054 -0.124 0.033 0.031 0.054 0.075 0.054 0.124 0 0.049 -0.021 0.093 -0.054 0.124"
					/>
					<path
						fill="#058e6e"
						d="m8.323 11.424s0.02 -0.051 0.022 -0.094c0.002 -0.036 -0.005 -0.072 -0.005 -0.072h0.017s0.013 0.039 0.013 0.072c0 0.034 -0.006 0.079 -0.006 0.079s-0.018 0.003 -0.024 0.006c-0.006 0.003 -0.027 0.01 -0.027 0.01"
					/>
				</g>
				<g id="Aragon" fill="#c8b100">
					<path
						fill="#ad1519"
						d="m8.344 10.486c0 0.439 -0.372 0.794 -0.835 0.794s-0.838 -0.355 -0.838 -0.794v-1.112h1.673v1.112"
					/>
					<path d="m6.668 10.471c0.005 0.234 0.098 0.408 0.191 0.522v-1.649h-0.189l-0.002 1.127z" />
					<path d="m7.036 11.141c0.052 0.028 0.124 0.074 0.201 0.092l-0.005 -1.899h-0.196v1.806z" />
					<path d="m7.409 11.275c0.077 0.008 0.134 0.006 0.196 0v-1.94h-0.196v1.94z" />
					<path d="m7.777 11.233c0.077 -0.015 0.163 -0.063 0.201 -0.088v-1.811h-0.196l-0.005 1.899z" />
					<path d="m8.16 10.975c0.082 -0.073 0.158 -0.237 0.186 -0.425l0.005 -1.215h-0.196l0.005 1.64z" />
				</g>
				<g id="Navarre">
					<path
						fill="#ad1519"
						d="m10.022 9.374v1.112c0 0.439 -0.376 0.794 -0.839 0.794 -0.463 0 -0.839 -0.355 -0.839 -0.794v-1.112h1.678"
					/>
					<path
						id="chains_half"
						fill="#c8b100"
						stroke="#c8b100"
						strokeWidth={0.008666666666666666}
						d="m9.09 10.205c0.002 -0.005 0.004 -0.009 0.006 -0.013l-0.142 -0.158 -0.056 0.024 -0.102 -0.113 0.033 -0.049 -0.178 -0.2c-0.002 0.001 -0.007 0.001 -0.009 0.001l0.001 0.134 0.058 0.017v0.149l-0.058 0.016 -0.001 0.136c0.028 0.009 0.049 0.029 0.058 0.056l0.107 0 0.017 -0.056h0.157l0.017 0.056zm-0.233 -0.617 0 0.054 0.092 0 0 -0.054zm-0.243 0.679c0.021 0 0.039 -0.016 0.039 -0.037s-0.017 -0.037 -0.039 -0.037c-0.022 0 -0.039 0.017 -0.039 0.037s0.017 0.037 0.039 0.037zm0.533 -0.324 -0.059 -0.016 0 -0.149 0.059 -0.017 0 -0.064c-0.028 -0.008 -0.05 -0.029 -0.06 -0.056h-0.089l-0.017 0.056h-0.157l-0.017 -0.056h-0.103c-0.003 0.007 -0.006 0.014 -0.01 0.02l0.179 0.199 0.056 -0.024 0.102 0.113 -0.033 0.048 0.139 0.155c0.003 -0.001 0.006 -0.003 0.009 -0.004zm-0.242 -0.046 -0.043 0.035 0.059 0.066 0.043 -0.035zm0.267 1.206c-0.041 -0.002 -0.075 -0.03 -0.084 -0.067 -0.056 -0.008 -0.108 -0.022 -0.158 -0.043l0.028 -0.048c0.043 0.018 0.089 0.03 0.136 0.037 0.01 -0.022 0.029 -0.039 0.053 -0.047l0 -0.187 -0.059 -0.016v-0.149l0.059 -0.016v-0.255c-0.002 -0.001 -0.004 -0.002 -0.007 -0.003l-0.133 0.147 0.033 0.048 -0.102 0.113 -0.056 -0.024 -0.11 0.122c0.019 0.029 0.018 0.067 -0.004 0.095 0.031 0.035 0.068 0.066 0.108 0.092l-0.028 0.048c-0.047 -0.03 -0.09 -0.066 -0.126 -0.107 -0.029 0.009 -0.062 0.004 -0.087 -0.017 -0.038 -0.031 -0.043 -0.085 -0.01 -0.121l0.005 -0.005c-0.023 -0.052 -0.039 -0.108 -0.044 -0.167l0.057 0c0.005 0.05 0.017 0.098 0.036 0.142 0.016 -0.002 0.033 0 0.049 0.005l0.111 -0.123 -0.033 -0.048 0.102 -0.113 0.056 0.024 0.133 -0.148c-0.003 -0.005 -0.005 -0.01 -0.007 -0.015l-0.092 0 -0.017 0.056h-0.157l-0.017 -0.056 -0.108 0c-0.009 0.025 -0.03 0.045 -0.056 0.054l0 0.135 -0.057 0v-0.134c-0.037 -0.011 -0.064 -0.044 -0.064 -0.082 0 -0.038 0.027 -0.072 0.064 -0.083l0 -0.135 -0.059 -0.016v-0.149l0.059 -0.017v-0.135c-0.036 -0.012 -0.061 -0.044 -0.061 -0.082 0 -0.048 0.041 -0.086 0.091 -0.086 0.041 0 0.075 0.025 0.087 0.059h0.103l0.017 -0.056h0.157l0.017 0.056h0.089c0.012 -0.034 0.045 -0.059 0.085 -0.059l0.002 0.279h-0.028v0.087h0.028l-0.001 0.72h-0.026v0.087h0.026zm-0.197 -0.61l-0.043 -0.035 -0.059 0.066 0.043 0.035zm-0.332 -0.615 -0.056 0 0 0.087 0.057 0zm0.305 0.38 0 -0.053 -0.095 0 0 0.053zm-0.353 0.323 -0.059 -0.013 -0.008 -0.148 0.058 -0.019 0 0.085c0 0.033 0.003 0.064 0.009 0.095zm0.049 -0.184 0.058 0.014s0.003 0.096 0.002 0.074c-0.001 -0.025 0.006 0.075 0.006 0.075l-0.059 0.019c-0.006 -0.03 -0.008 -0.061 -0.008 -0.093zm0.36 0.564 0.013 -0.057c-0.051 -0.016 -0.098 -0.039 -0.139 -0.07l-0.042 0.037c0.049 0.038 0.106 0.069 0.168 0.089zm-0.028 0.048 -0.043 0.041c-0.049 -0.018 -0.095 -0.042 -0.137 -0.07l0.013 -0.059c0.05 0.038 0.107 0.068 0.168 0.089z"
					/>
					<use xlinkHref="#chains_half" transform="matrix(-1,0,0,1,550.43,0)" />
					<path
						fill="#058e6e"
						stroke="none"
						d="m9.086 10.231c0 -0.048 0.041 -0.087 0.091 -0.087s0.091 0.039 0.091 0.087c0 0.048 -0.041 0.086 -0.091 0.086s-0.091 -0.038 -0.091 -0.086"
						strokeWidth={0.03333333333333333}
					/>
				</g>
				<g id="Castile" fill="#c8b100" strokeWidth={0.46}>
					<path
						fill="#ad1519"
						strokeWidth={0.017333333333333333}
						d="m6.671 9.375h1.673v-1.857h-1.673v1.857z"
					/>
					<path d="m7.245 7.947h-0.031v-0.031h-0.054v0.123h0.054v0.085h-0.116v0.246h0.062v0.493h-0.123v0.254h0.947v-0.254h-0.123v-0.493h0.062v-0.246h-0.116v-0.085h0.054v-0.123h-0.054v0.031h-0.031v-0.031h-0.054v0.031h-0.039v-0.031h-0.054v0.123h0.054v0.085h-0.115v-0.27h0.061v-0.123h-0.061v0.031h-0.031v-0.031h-0.054v0.031h-0.031v-0.031h-0.062v0.123h0.062v0.27h-0.116v-0.085h0.054v-0.123h-0.054v0.031h-0.031v-0.031h-0.062v0.031zm-0.208 1.171h0.947m-0.947 -0.062h0.947m-0.947 -0.062h0.947m-0.947 -0.062h0.947m-0.947 -0.069h0.947m-0.824 -0.054h0.701m-0.701 -0.062h0.701m-0.701 -0.069h0.701m-0.701 -0.061h0.701m-0.701 -0.062h0.701m-0.701 -0.062h0.701m-0.701 -0.062h0.701m-0.763 -0.062h0.824m-0.824 -0.062h0.824m-0.824 -0.062h0.824m-0.824 -0.061h0.824m-0.709 -0.062h0.593m-0.354 -0.062h0.116m-0.116 -0.062h0.116m-0.116 -0.062h0.116m-0.116 -0.062h0.116m-0.177 -0.077h0.239m-0.416 0.262h0.123m-0.177 -0.077h0.231m-0.231 1.132v-0.062m0 -0.062v-0.062m-0.062 0.062v0.062m0.116 0v-0.062m0.061 0.123v-0.062m0 -0.062v-0.062m0 -0.069v-0.054m0 -0.062v-0.069m-0.061 0.254v-0.069m-0.116 0.069v-0.069m0.239 0v0.069m0.054 -0.069v-0.054m-0.177 -0.062v0.062m0.123 -0.062v0.062m0.116 -0.062v0.062m-0.062 -0.062v-0.069m0.062 -0.061v0.061m0 -0.185v0.062m-0.062 -0.123v0.062m0.062 -0.123v0.062m-0.116 -0.062v0.062m-0.123 -0.062v0.062m-0.054 -0.123v0.062m0.115 -0.062v0.062m0.116 -0.062v0.062m0.062 -0.123v0.062m-0.116 -0.062v0.062m-0.123 -0.062v0.062m-0.054 -0.123v0.061m0.231 -0.061v0.061m-0.116 -0.185v0.062m0.532 -0.062h-0.123m0.177 -0.077h-0.231m0.231 1.132v-0.062m0 -0.062v-0.062m0.062 0.062v0.062m-0.116 0v-0.062m-0.062 0.123v-0.062m0 -0.062v-0.062m0 -0.069v-0.054m0 -0.062v-0.069m0.062 0.254v-0.069m0.116 0.069v-0.069m-0.239 0v0.069m-0.054 -0.069v-0.054m0.177 -0.062v0.062m-0.123 -0.062v0.062m-0.115 -0.062v0.062m0.061 -0.062v-0.069m-0.061 -0.061v0.061m0 -0.185v0.062m0.061 -0.123v0.062m-0.061 -0.123v0.062m0.115 -0.062v0.062m0.123 -0.062v0.062m0.054 -0.123v0.062m-0.116 -0.062v0.062m-0.116 -0.062v0.062m-0.061 -0.123v0.062m0.115 -0.062v0.062m0.123 -0.062v0.062m0.054 -0.123v0.061m-0.231 -0.061v0.061m0.116 -0.185v0.062m-0.239 0.624v-0.069m0 -0.185v-0.062m0 0.185v-0.062m0 -0.185v-0.062m0 -0.062v-0.061m0 -0.123v-0.062m0 -0.062v-0.062m-0.293 0.162h0.123m0.116 -0.185h0.116m0.115 0.185h0.123" />
					<path d="m7.668 9.118v-0.162c0 -0.031 -0.015 -0.123 -0.162 -0.123 -0.139 0 -0.154 0.093 -0.154 0.123v0.162h0.316z" />
					<path d="m7.406 8.964l-0.077 -0.008c0 -0.031 0.008 -0.077 0.031 -0.092l0.069 0.054c-0.008 0.008 -0.023 0.031 -0.023 0.046z" />
					<path d="m7.537 8.887l0.039 -0.069c-0.015 -0.008 -0.046 -0.015 -0.069 -0.015 -0.015 0 -0.046 0.008 -0.062 0.015l0.038 0.069h0.054z" />
					<path d="m7.614 8.964l0.077 -0.008c0 -0.031 -0.008 -0.077 -0.031 -0.092l-0.069 0.054c0.008 0.008 0.023 0.031 0.023 0.046z" />
					<path d="m7.391 8.694v-0.17c0 -0.046 -0.031 -0.085 -0.085 -0.085s-0.085 0.039 -0.085 0.085v0.17h0.169z" />
					<path d="m7.63 8.694v-0.17c0 -0.046 0.031 -0.085 0.085 -0.085 0.054 0 0.085 0.039 0.085 0.085v0.17h-0.17z" />
					<path d="m7.337 8.278l0.008 -0.154h-0.146l0.016 0.154h0.123z" />
					<path d="m7.568 8.278l0.015 -0.154h-0.146l0.008 0.154h0.123z" />
					<path d="m7.684 8.278l-0.015 -0.154h0.154l-0.015 0.154h-0.123z" />
					<g fill="#0039f0" stroke="none">
						<path d="m7.614 9.118v-0.139c0 -0.023 -0.015 -0.093 -0.108 -0.093 -0.085 0 -0.1 0.069 -0.1 0.093v0.139h0.208z" />
						<path d="m7.376 8.679v-0.146c0 -0.038 -0.023 -0.077 -0.069 -0.077s-0.069 0.039 -0.069 0.077v0.146h0.139z" />
						<path d="m7.645 8.679v-0.146c0 -0.038 0.023 -0.077 0.069 -0.077 0.046 0 0.069 0.039 0.069 0.077v0.146h-0.139z" />
					</g>
				</g>
				<g id="Leon">
					<path fill="#ccc" d="m8.343 9.375h1.677v-1.857h-1.677v1.857z" />
					<path
						fill="#db4446"
						strokeWidth={0.013}
						d="m9.198 7.975l0.002 -0.021 0.003 -0.011s-0.054 0.004 -0.082 -0.004 -0.054 -0.02 -0.08 -0.042c-0.026 -0.023 -0.037 -0.037 -0.056 -0.039 -0.045 -0.007 -0.08 0.013 -0.08 0.013s0.034 0.012 0.059 0.044 0.053 0.047 0.065 0.051c0.02 0.006 0.089 0.002 0.107 0.002 0.019 0.001 0.061 0.006 0.061 0.006z"
					/>
					<g fill="none" strokeWidth={0.39}>
						<path
							fill="#ed72aa"
							d="m9.449 7.9s0 0.024 0.003 0.047c0.002 0.022 -0.007 0.041 -0.004 0.054s0.005 0.022 0.01 0.031c0.005 0.009 0.007 0.031 0.007 0.031s-0.013 -0.009 -0.025 -0.018c-0.012 -0.009 -0.02 -0.015 -0.02 -0.015s0.002 0.024 0.003 0.034c0.001 0.01 0.007 0.03 0.017 0.041 0.01 0.011 0.029 0.03 0.035 0.044 0.006 0.015 0.005 0.048 0.005 0.048s-0.015 -0.025 -0.029 -0.03c-0.013 -0.005 -0.042 -0.021 -0.042 -0.021s0.026 0.026 0.026 0.052c0 0.025 -0.011 0.053 -0.011 0.053s-0.012 -0.023 -0.028 -0.037c-0.016 -0.015 -0.038 -0.03 -0.038 -0.03s0.017 0.039 0.017 0.065c0 0.026 -0.005 0.082 -0.005 0.082s-0.013 -0.021 -0.026 -0.032c-0.013 -0.01 -0.029 -0.019 -0.034 -0.026 -0.005 -0.007 0.016 0.021 0.018 0.039 0.002 0.017 0.011 0.078 0.064 0.156 0.031 0.046 0.08 0.126 0.183 0.099 0.104 -0.026 0.065 -0.166 0.043 -0.231 -0.022 -0.065 -0.033 -0.137 -0.031 -0.162 0.001 -0.025 0.019 -0.099 0.017 -0.113 -0.002 -0.014 -0.008 -0.067 0.005 -0.109 0.013 -0.044 0.024 -0.062 0.032 -0.08 0.007 -0.018 0.013 -0.029 0.015 -0.045s0.002 -0.046 0.002 -0.046 0.019 0.035 0.024 0.048c0.005 0.013 0.005 0.05 0.005 0.05s0.004 -0.037 0.033 -0.056 0.063 -0.038 0.071 -0.048 0.011 -0.017 0.011 -0.017 -0.003 0.064 -0.021 0.089c-0.012 0.016 -0.059 0.07 -0.059 0.07s0.024 -0.009 0.041 -0.01c0.017 -0.001 0.029 0 0.029 0s-0.021 0.016 -0.047 0.055c-0.027 0.039 -0.016 0.042 -0.035 0.074s-0.035 0.033 -0.059 0.053c-0.036 0.029 -0.017 0.145 -0.012 0.162 0.005 0.017 0.068 0.159 0.069 0.193 0.001 0.034 0.007 0.111 -0.053 0.16 -0.039 0.032 -0.102 0.032 -0.117 0.041 -0.014 0.009 -0.043 0.038 -0.043 0.097 0 0.06 0.021 0.069 0.038 0.084 0.017 0.015 0.039 0.007 0.043 0.018 0.005 0.011 0.007 0.018 0.015 0.025 0.007 0.007 0.012 0.015 0.01 0.027 -0.003 0.013 -0.03 0.041 -0.04 0.062 -0.01 0.02 -0.029 0.074 -0.029 0.082s-0.002 0.033 0.006 0.046c0 0 0.03 0.035 0.01 0.042 -0.013 0.005 -0.026 -0.008 -0.032 -0.007 -0.018 0.005 -0.028 0.016 -0.033 0.015 -0.012 -0.002 -0.012 -0.008 -0.013 -0.025 -0.001 -0.017 0 -0.024 -0.006 -0.024 -0.007 0 -0.011 0.006 -0.012 0.015s-0.001 0.03 -0.01 0.03 -0.02 -0.015 -0.028 -0.018 -0.028 -0.007 -0.029 -0.016c-0.001 -0.009 0.012 -0.028 0.025 -0.032 0.013 -0.003 0.025 -0.01 0.017 -0.017 -0.009 -0.007 -0.017 -0.007 -0.025 0 -0.008 0.007 -0.026 0.001 -0.025 -0.009 0.001 -0.01 0.004 -0.023 0.002 -0.029 -0.001 -0.006 -0.016 -0.017 0.003 -0.027 0.02 -0.01 0.028 0.009 0.047 0.006s0.029 -0.01 0.036 -0.022 0.006 -0.035 -0.007 -0.05c-0.013 -0.015 -0.026 -0.017 -0.031 -0.027 -0.005 -0.009 -0.012 -0.031 -0.012 -0.031s0.004 0.04 0.001 0.046 -0.001 0.03 -0.001 0.03 -0.013 -0.015 -0.024 -0.026c-0.011 -0.011 -0.022 -0.046 -0.022 -0.046s-0.001 0.032 -0.001 0.045c0 0.012 0.014 0.024 0.01 0.029 -0.005 0.004 -0.028 -0.024 -0.034 -0.029 -0.006 -0.005 -0.025 -0.019 -0.034 -0.035s-0.015 -0.039 -0.017 -0.047c-0.002 -0.008 -0.006 -0.044 -0.002 -0.053 0.006 -0.013 0.016 -0.038 0.016 -0.038h-0.047c-0.025 0 -0.043 -0.008 -0.053 0.009s-0.005 0.051 0.007 0.096c0.012 0.044 0.019 0.066 0.016 0.074 -0.004 0.008 -0.019 0.026 -0.025 0.03 -0.006 0.004 -0.023 0.002 -0.03 -0.001 -0.007 -0.003 -0.019 -0.009 -0.042 -0.009s-0.037 0.001 -0.046 -0.001c-0.009 -0.002 -0.029 -0.013 -0.039 -0.01s-0.026 0.011 -0.022 0.024c0.007 0.02 -0.007 0.025 -0.017 0.024 -0.01 -0.001 -0.018 -0.005 -0.03 -0.008 -0.012 -0.004 -0.03 0 -0.028 -0.014 0.002 -0.014 0.007 -0.015 0.013 -0.025 0.006 -0.011 0.008 -0.017 0.001 -0.018 -0.008 -0.001 -0.017 -0.002 -0.023 0.004 -0.007 0.005 -0.017 0.017 -0.025 0.013 -0.009 -0.005 -0.015 -0.014 -0.015 -0.036 0 -0.021 -0.023 -0.04 -0.002 -0.039 0.021 0.001 0.047 0.016 0.052 0.004s0.002 -0.017 -0.009 -0.026 -0.025 -0.014 -0.01 -0.026c0.015 -0.012 0.019 -0.012 0.025 -0.018 0.006 -0.006 0.014 -0.026 0.024 -0.021 0.021 0.01 0.001 0.024 0.022 0.047 0.021 0.023 0.034 0.031 0.069 0.028 0.035 -0.004 0.044 -0.008 0.044 -0.018 0 -0.01 -0.003 -0.027 -0.004 -0.035 -0.001 -0.007 0.005 -0.033 0.005 -0.033s-0.016 0.01 -0.021 0.02c-0.004 0.01 -0.014 0.027 -0.014 0.027s-0.004 -0.02 -0.003 -0.036c0.001 -0.01 0.004 -0.026 0.004 -0.03 -0.001 -0.009 -0.008 -0.031 -0.008 -0.031s-0.005 0.024 -0.009 0.031c-0.004 0.007 -0.005 0.036 -0.005 0.036s-0.022 -0.019 -0.016 -0.052c0.004 -0.025 -0.004 -0.058 0.004 -0.069 0.007 -0.011 0.025 -0.055 0.069 -0.056 0.043 -0.002 0.077 0.002 0.092 0.001 0.015 -0.001 0.069 -0.011 0.069 -0.011s-0.099 -0.051 -0.121 -0.066c-0.023 -0.015 -0.058 -0.054 -0.069 -0.072 -0.011 -0.018 -0.022 -0.053 -0.022 -0.053s-0.018 0.001 -0.034 0.01c-0.016 0.009 -0.032 0.022 -0.041 0.033s-0.024 0.035 -0.024 0.035 0.003 -0.031 0.003 -0.041 -0.002 -0.029 -0.002 -0.029 -0.011 0.043 -0.034 0.059c-0.023 0.016 -0.049 0.038 -0.049 0.038s0.003 -0.024 0.003 -0.029c0 -0.005 0.006 -0.033 0.006 -0.033s-0.016 0.024 -0.04 0.029c-0.025 0.004 -0.06 0.004 -0.063 0.019 -0.003 0.015 0.007 0.036 0.001 0.046s-0.018 0.018 -0.018 0.018 -0.014 -0.012 -0.026 -0.013c-0.012 -0.001 -0.024 0.005 -0.024 0.005s-0.01 -0.013 -0.006 -0.022c0.004 -0.009 0.022 -0.022 0.018 -0.028 -0.005 -0.005 -0.02 0.002 -0.029 0.006 -0.009 0.005 -0.029 0.009 -0.027 -0.006 0.002 -0.015 0.007 -0.024 0.002 -0.035 -0.005 -0.011 -0.002 -0.018 0.006 -0.02 0.007 -0.003 0.037 0.001 0.04 -0.006 0.003 -0.007 -0.007 -0.016 -0.027 -0.02 -0.02 -0.005 -0.029 -0.016 -0.019 -0.026 0.011 -0.01 0.013 -0.013 0.018 -0.021 0.005 -0.009 0.007 -0.025 0.025 -0.017 0.018 0.008 0.014 0.028 0.033 0.034 0.019 0.006 0.063 -0.003 0.072 -0.008s0.04 -0.028 0.05 -0.033c0.01 -0.005 0.054 -0.037 0.054 -0.037s-0.025 -0.018 -0.035 -0.027c-0.009 -0.009 -0.026 -0.03 -0.035 -0.035 -0.008 -0.004 -0.05 -0.02 -0.064 -0.021 -0.014 -0.001 -0.057 -0.016 -0.057 -0.016s0.02 -0.006 0.026 -0.012c0.006 -0.005 0.021 -0.019 0.029 -0.018 0.007 0.001 0.009 0.001 0.009 0.001s-0.04 -0.002 -0.049 -0.004c-0.008 -0.003 -0.033 -0.018 -0.042 -0.018s-0.028 0.004 -0.028 0.004 0.025 -0.016 0.046 -0.02c0.021 -0.003 0.037 -0.003 0.037 -0.003s-0.032 -0.009 -0.04 -0.019c-0.007 -0.011 -0.015 -0.027 -0.021 -0.034 -0.006 -0.007 -0.009 -0.019 -0.02 -0.02s-0.028 0.013 -0.039 0.012 -0.018 -0.007 -0.019 -0.022c-0.001 -0.015 0 -0.01 -0.003 -0.018 -0.004 -0.008 -0.019 -0.027 -0.005 -0.031 0.014 -0.005 0.044 0.003 0.047 -0.003 0.003 -0.005 -0.016 -0.022 -0.028 -0.028 -0.012 -0.006 -0.032 -0.017 -0.022 -0.026 0.01 -0.009 0.021 -0.012 0.026 -0.02s0.012 -0.03 0.025 -0.023c0.012 0.007 0.029 0.042 0.039 0.039 0.009 -0.003 0.01 -0.028 0.008 -0.038 -0.002 -0.011 0 -0.029 0.009 -0.028s0.017 0.014 0.032 0.015c0.015 0.001 0.038 -0.004 0.036 0.007 -0.002 0.011 -0.01 0.024 -0.021 0.035 -0.01 0.012 -0.015 0.035 -0.008 0.05 0.007 0.015 0.024 0.04 0.039 0.049s0.043 0.017 0.061 0.028c0.018 0.012 0.059 0.045 0.073 0.048s0.028 0.011 0.028 0.011 0.016 -0.007 0.038 -0.007 0.071 0.003 0.09 -0.005 0.043 -0.021 0.036 -0.038c-0.008 -0.017 -0.049 -0.032 -0.045 -0.045s0.019 -0.014 0.044 -0.015c0.025 -0.001 0.06 0.005 0.067 -0.031 0.007 -0.035 0.009 -0.056 -0.027 -0.064 -0.036 -0.008 -0.062 -0.009 -0.069 -0.035 -0.007 -0.026 -0.013 -0.032 -0.006 -0.039 0.008 -0.007 0.021 -0.011 0.047 -0.012 0.027 -0.002 0.057 -0.002 0.065 -0.008 0.008 -0.006 0.01 -0.023 0.02 -0.03 0.01 -0.007 0.051 -0.013 0.051 -0.013s0.049 0.024 0.093 0.057c0.04 0.03 0.077 0.074 0.077 0.074"
						/>
						<path d="m8.967 8.113s-0.027 0.008 -0.037 0.022c-0.012 0.018 -0.011 0.036 -0.011 0.036s0.023 -0.019 0.052 -0.011c0.029 0.008 0.032 0.011 0.044 0.01s0.042 -0.012 0.042 -0.012 -0.025 0.029 -0.022 0.048c0.003 0.019 0.006 0.028 0.006 0.038 -0.002 0.024 -0.02 0.054 -0.02 0.054s0.01 -0.006 0.035 -0.012c0.024 -0.005 0.045 -0.017 0.058 -0.027 0.013 -0.01 0.03 -0.034 0.03 -0.034s-0.005 0.033 0 0.047c0.006 0.015 0.008 0.056 0.008 0.056s0.016 -0.014 0.028 -0.021c0.006 -0.004 0.023 -0.013 0.03 -0.023 0.005 -0.007 0.011 -0.035 0.011 -0.035s0.004 0.03 0.013 0.045c0.009 0.014 0.023 0.058 0.023 0.058s0.01 -0.029 0.02 -0.04 0.023 -0.027 0.023 -0.036c0.001 -0.009 -0.003 -0.028 -0.003 -0.028l0.013 0.028m-0.38 0.02s0.016 -0.028 0.031 -0.037c0.015 -0.009 0.036 -0.025 0.042 -0.027 0.005 -0.002 0.03 -0.015 0.03 -0.015m0.033 0.172s0.036 -0.018 0.047 -0.025c0.023 -0.013 0.039 -0.037 0.039 -0.037" />
						<path
							fill="none"
							strokeWidth={0.008666666666666666}
							d="m9.419 8.03s-0.011 -0.016 -0.014 -0.022c-0.003 -0.005 -0.008 -0.016 -0.008 -0.016"
						/>
						<path
							fill="none"
							d="m9.278 8.58s0.068 0.042 0.066 0.077c-0.002 0.035 -0.038 0.08 -0.038 0.08"
						/>
					</g>
					<path
						fill="#000"
						strokeWidth={0.008666666666666666}
						d="m9.102 7.875s-0.006 -0.016 -0.007 -0.021c-0.001 -0.004 -0.004 -0.01 -0.004 -0.01s0.029 0 0.028 0.009c-0.001 0.009 -0.009 0.009 -0.011 0.012 -0.002 0.004 -0.006 0.009 -0.006 0.009z"
					/>
					<path
						fill="#000"
						strokeWidth={0.0016666666666666668}
						d="m9.235 7.828l-0.002 -0.014s0.026 0 0.038 0.009c0.019 0.013 0.031 0.034 0.03 0.035 -0.003 0.003 -0.018 -0.009 -0.028 -0.012 0 0 -0.008 0.002 -0.015 0.002 -0.008 0 -0.011 -0.004 -0.012 -0.007 -0.001 -0.004 0.001 -0.01 0.001 -0.01l-0.011 -0.002z"
					/>
					<g fill="#000" strokeWidth={0.26}>
						<path d="m9.103 8.005l0.011 -0.018 0.011 0.016 -0.022 0.001" />
						<path d="m9.13 8.004l0.013 -0.018 0.014 0.016 -0.028 0.002" />
						<path d="m9.118 7.894l0.027 0.01 -0.025 0.013 -0.003 -0.022" />
						<path d="m9.151 7.903l0.024 0.006 -0.02 0.015 -0.005 -0.021" />
					</g>
					<g fill="#db4446" strokeWidth={0.39}>
						<path d="m8.729 7.869s0.016 0.011 0.028 0.013c0.012 0.002 0.025 0.002 0.027 0.002 0.002 0 0.006 -0.018 0.004 -0.03 -0.007 -0.04 -0.043 -0.049 -0.043 -0.049s0.011 0.024 0.006 0.036c-0.008 0.016 -0.022 0.029 -0.022 0.029z" />
						<path d="m8.653 7.904s-0.014 -0.026 -0.044 -0.022c-0.03 0.004 -0.05 0.027 -0.05 0.027s0.033 -0.001 0.042 0.004c0.012 0.008 0.016 0.029 0.016 0.029s0.018 -0.011 0.024 -0.018c0.005 -0.007 0.013 -0.02 0.013 -0.02z" />
						<path d="m8.616 8.008s-0.026 0.004 -0.04 0.02c-0.014 0.016 -0.012 0.047 -0.012 0.047s0.017 -0.018 0.032 -0.018c0.015 0 0.039 0.005 0.039 0.005s-0.007 -0.019 -0.007 -0.027 -0.011 -0.027 -0.011 -0.027z" />
						<path d="m8.702 8.346s-0.014 -0.015 -0.039 -0.011c-0.025 0.005 -0.041 0.032 -0.041 0.032s0.021 -0.006 0.033 -0.003c0.012 0.003 0.021 0.015 0.021 0.015s0.011 -0.01 0.015 -0.015 0.01 -0.019 0.01 -0.019z" />
						<path d="m8.674 8.445s-0.021 -0.003 -0.039 0.011c-0.018 0.014 -0.019 0.042 -0.019 0.042s0.017 -0.014 0.03 -0.012c0.013 0.002 0.029 0.009 0.029 0.009s0.003 -0.017 0.004 -0.021c0.003 -0.013 -0.006 -0.028 -0.006 -0.028z" />
						<path d="m8.722 8.536s-0.002 0.026 0.011 0.043c0.013 0.017 0.038 0.02 0.038 0.02s-0.008 -0.018 -0.009 -0.027c-0.002 -0.013 0.011 -0.025 0.011 -0.025s-0.012 -0.013 -0.024 -0.013c-0.012 0 -0.026 0.002 -0.026 0.002z" />
						<path d="m8.967 8.771s-0.017 -0.021 -0.04 -0.021c-0.024 0.001 -0.048 0.023 -0.048 0.023s0.029 -0.002 0.037 0.007c0.008 0.01 0.015 0.022 0.015 0.022s0.013 -0.007 0.019 -0.012c0.006 -0.004 0.018 -0.02 0.018 -0.02z" />
						<path d="m8.894 8.864s-0.031 -0.005 -0.046 0.012c-0.015 0.016 -0.014 0.045 -0.014 0.045s0.019 -0.02 0.036 -0.019 0.036 0.011 0.036 0.011 -0.003 -0.018 -0.005 -0.026c-0.002 -0.008 -0.006 -0.023 -0.006 -0.023z" />
						<path d="m8.961 8.963s-0.015 0.021 -0.004 0.038 0.035 0.025 0.035 0.025 -0.009 -0.012 -0.005 -0.027c0.003 -0.011 0.022 -0.027 0.022 -0.027l-0.049 -0.01z" />
						<path d="m9.375 9.004s-0.027 -0.006 -0.042 0.003c-0.015 0.009 -0.027 0.046 -0.027 0.046s0.025 -0.021 0.043 -0.018c0.018 0.003 0.031 0.01 0.031 0.01s0.003 -0.015 0.001 -0.026c-0.001 -0.006 -0.005 -0.015 -0.005 -0.015z" />
						<path d="m9.388 9.103s-0.021 0.021 -0.013 0.039c0.008 0.018 0.021 0.037 0.021 0.037s-0.001 -0.027 0.008 -0.034c0.012 -0.011 0.035 -0.012 0.035 -0.012s-0.018 -0.016 -0.024 -0.018c-0.006 -0.002 -0.026 -0.012 -0.026 -0.012z" />
						<path d="m9.492 9.135s-0.01 0.026 0.009 0.043c0.02 0.017 0.037 0.019 0.037 0.019s-0.015 -0.027 -0.011 -0.041c0.005 -0.015 0.018 -0.024 0.018 -0.024s-0.025 -0.008 -0.028 -0.007c-0.004 0.001 -0.025 0.011 -0.025 0.011z" />
					</g>
					<g fill="#c8b100" strokeWidth={0.26}>
						<path d="m9.429 7.757l-0.01 0.001c0 0.001 -0.005 0.008 -0.009 0.012 -0.009 0.008 -0.022 0.009 -0.029 0.002 -0.004 -0.004 -0.005 -0.009 -0.005 -0.014 -0.006 0.003 -0.012 0.003 -0.017 0 -0.009 -0.005 -0.011 -0.017 -0.005 -0.026 0.001 -0.002 0.002 -0.005 0.004 -0.006l-0.001 -0.011 -0.012 0.003 -0.003 0.006c-0.007 0.008 -0.018 0.01 -0.023 0.006 -0.003 -0.002 -0.005 -0.009 -0.004 -0.009 0 0 -0.003 0.003 -0.006 0.004 -0.018 0.004 -0.025 -0.035 -0.026 -0.045l-0.006 0.008s0.005 0.023 0.003 0.043c-0.003 0.02 -0.01 0.04 -0.01 0.04 0.025 0.006 0.062 0.027 0.099 0.055s0.066 0.059 0.078 0.081c0 0 0.019 -0.011 0.039 -0.017s0.045 -0.007 0.045 -0.007l0.007 -0.007c-0.011 0.002 -0.053 0.003 -0.052 -0.014 0 -0.003 0.002 -0.006 0.003 -0.006 0 0 -0.007 0 -0.01 -0.002 -0.006 -0.004 -0.006 -0.014 0.001 -0.023l0.006 -0.004 0 -0.011 -0.011 0.002c-0.001 0.001 -0.004 0.003 -0.005 0.004 -0.009 0.008 -0.022 0.008 -0.029 0.001 -0.004 -0.004 -0.006 -0.01 -0.004 -0.015 -0.005 0.001 -0.011 0.001 -0.015 -0.002 -0.009 -0.005 -0.01 -0.017 -0.004 -0.027 0.003 -0.005 0.009 -0.01 0.01 -0.011l-0.002 -0.01h0z" />
						<g fill="#000" strokeWidth={0.05}>
							<path d="m9.354 7.78c0.002 -0.002 0.005 -0.002 0.008 0s0.003 0.005 0.002 0.007c-0.002 0.002 -0.005 0.002 -0.008 0 -0.002 -0.002 -0.003 -0.005 -0.002 -0.007z" />
							<path d="m9.386 7.806l-0.011 -0.008c-0.002 -0.001 -0.002 -0.004 -0.001 -0.005 0.001 -0.001 0.004 -0.001 0.006 0l0.011 0.009 0.011 0.008c0.002 0.001 0.003 0.004 0.001 0.005s-0.004 0.001 -0.006 0l-0.011 -0.009" />
							<path d="m9.328 7.767l-0.009 -0.005c-0.002 -0.001 -0.003 -0.004 -0.002 -0.006s0.004 -0.002 0.006 -0.001l0.009 0.005 0.009 0.005c0.002 0.001 0.003 0.004 0.002 0.005 -0.001 0.002 -0.004 0.002 -0.006 0.001l-0.009 -0.005" />
							<path d="m9.293 7.743c0.002 -0.002 0.005 -0.002 0.008 0 0.003 0.002 0.003 0.005 0.002 0.007 -0.002 0.002 -0.005 0.002 -0.008 0s-0.003 -0.005 -0.002 -0.007z" />
							<path d="m9.421 7.831c0.002 -0.002 0.001 -0.005 -0.002 -0.007 -0.003 -0.002 -0.006 -0.002 -0.008 0 -0.001 0.002 -0.001 0.005 0.002 0.007s0.006 0.002 0.008 0z" />
							<path d="m9.44 7.853l0.007 0.007c0.002 0.002 0.004 0.002 0.006 0.001 0.001 -0.001 0.001 -0.004 0 -0.005l-0.007 -0.007 -0.007 -0.007c-0.002 -0.002 -0.005 -0.002 -0.006 -0.001 -0.002 0.001 -0.001 0.004 0 0.005l0.007 0.007" />
							<path d="m9.472 7.88c0.002 -0.002 0.001 -0.005 -0.002 -0.007 -0.003 -0.002 -0.006 -0.002 -0.008 0s-0.001 0.005 0.002 0.007c0.003 0.002 0.006 0.002 0.008 0z" />
						</g>
						<path d="m9.38 7.679l-0.02 0 -0.004 0.029 0.002 0.005 0.005 0 0.025 -0.017 -0.009 -0.017" />
						<path d="m9.38 7.679l-0.02 0 -0.004 0.029 0.002 0.005 0.005 0 0.025 -0.017 -0.009 -0.017" />
						<path d="m9.327 7.695l-0.001 0.018 0.031 0.004 0.005 -0.002 -0.001 -0.005 -0.018 -0.024 -0.017 0.009" />
						<path d="m9.39 7.731l-0.016 0.009 -0.018 -0.024 0 -0.005 0.005 -0.002 0.031 0.004 -0.001 0.018" />
						<path d="m9.35 7.708c0.003 -0.004 0.009 -0.006 0.013 -0.003 0.005 0.002 0.006 0.008 0.003 0.012s-0.009 0.006 -0.013 0.003c-0.005 -0.003 -0.006 -0.008 -0.003 -0.012z" />
						<path d="m9.279 7.678c-0.001 0 -0.004 -0.015 -0.009 -0.024 -0.003 -0.006 -0.013 -0.014 -0.013 -0.014 0.001 -0.002 0.014 -0.006 0.029 0.003 0.013 0.01 -0.001 0.029 -0.001 0.029s-0.003 0.005 -0.006 0.006z" />
						<path d="m9.313 7.689l-0.014 0.012 -0.023 -0.02 0.002 -0.003 0.001 -0.005 0.031 -0.002 0.003 0.018" />
						<path d="m9.275 7.676c0.002 -0.005 0.006 -0.008 0.009 -0.007 0.004 0.001 0.005 0.006 0.003 0.011s-0.006 0.008 -0.01 0.007c-0.004 -0.001 -0.005 -0.006 -0.003 -0.011z" />
						<path d="m9.456 7.726l-0.02 -0.002 -0.008 0.028 0.002 0.005 0.005 0 0.028 -0.014 -0.006 -0.018" />
						<path d="m9.4 7.734l-0.003 0.018 0.03 0.008 0.005 -0.001 0 -0.005 -0.014 -0.026 -0.018 0.007" />
						<path d="m9.458 7.779l-0.018 0.007 -0.014 -0.026 0 -0.005 0.005 -0.001 0.03 0.008 -0.003 0.018" />
						<path d="m9.422 7.751c0.003 -0.004 0.009 -0.004 0.013 -0.001 0.004 0.003 0.005 0.009 0.002 0.013s-0.009 0.004 -0.014 0.001c-0.004 -0.003 -0.005 -0.009 -0.001 -0.013z" />
						<path d="m9.521 7.787l0.004 0.018 -0.029 0.01 -0.005 -0.001 0 -0.005 0.012 -0.027 0.019 0.005" />
						<path d="m9.516 7.84l-0.019 0.004 -0.01 -0.028 0.001 -0.005 0.005 -0.001 0.028 0.012 -0.006 0.017" />
						<path d="m9.466 7.789l-0.006 0.017 0.028 0.011 0.005 -0.001 0.001 -0.005 -0.01 -0.028 -0.019 0.004" />
						<path d="m9.497 7.821c0.004 -0.004 0.004 -0.009 0.001 -0.013 -0.004 -0.004 -0.01 -0.004 -0.014 -0.001 -0.004 0.004 -0.004 0.009 0 0.013 0.003 0.004 0.01 0.004 0.013 0.001z" />
						<path d="m9.543 7.881c0 0 0.017 0.001 0.026 0.003 0.007 0.001 0.017 0.009 0.017 0.009 0.002 -0.001 0.004 -0.014 -0.009 -0.026 -0.013 -0.009 -0.029 0.007 -0.029 0.007s-0.004 0.004 -0.005 0.007z" />
						<path d="m9.525 7.851l-0.01 0.015 0.025 0.017 0.003 -0.003 0.004 -0.001 -0.004 -0.029 -0.019 0.001" />
						<path d="m9.546 7.884c0.005 -0.002 0.007 -0.007 0.005 -0.01s-0.007 -0.003 -0.012 -0.001 -0.007 0.007 -0.005 0.01c0.002 0.003 0.007 0.003 0.012 0.001z" />
					</g>
				</g>
				<g id="inescutcheon" strokeWidth={0.61}>
					<path
						fill="#ad1519"
						cx={250.43}
						cy={281.01}
						rx={16.26}
						ry={18.3}
						d="M8.89 9.367A0.542 0.61 0 0 1 8.348 9.977A0.542 0.61 0 0 1 7.806 9.367A0.542 0.61 0 0 1 8.89 9.367z"
					/>
					<path
						fill="#005bbf"
						cx={250.44}
						cy={280.97}
						rx={11.44}
						ry={13.42}
						d="M8.729 9.366A0.381 0.447 0 0 1 8.348 9.813A0.381 0.447 0 0 1 7.967 9.366A0.381 0.447 0 0 1 8.729 9.366z"
					/>
					<g id="fdl" fill="#c8b100" strokeWidth={0.34}>
						<path
							strokeLinejoin="round"
							d="m8.168 9.058s-0.045 0.049 -0.045 0.095c0 0.046 0.019 0.085 0.019 0.085 -0.007 -0.018 -0.025 -0.031 -0.047 -0.031 -0.028 0 -0.05 0.021 -0.05 0.047 0 0.007 0.005 0.019 0.008 0.026l0.016 0.033c0.005 -0.012 0.018 -0.019 0.033 -0.019 0.02 0 0.036 0.015 0.036 0.034 0 0.003 0 0.006 -0.001 0.008l-0.041 0v0.034h0.036l-0.027 0.054 0.036 -0.014 0.027 0.03 0.028 -0.03 0.036 0.014 -0.027 -0.054h0.036v-0.034l-0.041 0c-0.001 -0.003 -0.001 -0.005 -0.001 -0.008 0 -0.019 0.016 -0.034 0.035 -0.034 0.015 0 0.027 0.007 0.033 0.019l0.016 -0.033c0.003 -0.006 0.008 -0.018 0.008 -0.026 0 -0.026 -0.022 -0.047 -0.05 -0.047 -0.022 0 -0.04 0.013 -0.047 0.031 0 0 0.019 -0.038 0.019 -0.085 0 -0.046 -0.046 -0.095 -0.046 -0.095z"
						/>
						<path d="m8.096 9.37h0.145v-0.034h-0.145v0.034z" />
					</g>
					<use xlinkHref="#fdl" x={10.63} />
					<use xlinkHref="#fdl" x={5.31} y={9.14} />
				</g>
			</g>
		</g>
	</svg>
);

export default ESFlag;